 // import React, { useState, useEffect } from 'react';
// import { database, ref, get, update, set } from '../../firebase';
// import { Wallet, ArrowRightLeft, AlertCircle, CheckCircle2, Loader2, Clock, Shield, DollarSign, AlertTriangle, X } from 'lucide-react';

// // Dialog Component for Transfer
// const TransferDialog = ({ isOpen, onClose, title, message, type = 'info', onConfirm }) => {
//   if (!isOpen) return null;

//   const getDialogStyles = () => {
//     const bgColor = '#132131';
    
//     switch (type) {
//       case 'success':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-green-500/30',
//           icon: <CheckCircle2 className="text-green-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       case 'error':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-red-500/30',
//           icon: <AlertCircle className="text-red-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       case 'warning':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-yellow-500/30',
//           icon: <AlertTriangle className="text-yellow-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       default:
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-primary/30',
//           icon: <AlertCircle className="text-blue-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//     }
//   };

//   const styles = getDialogStyles();

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <div 
//         className="absolute inset-0 bg-black/70 backdrop-blur-sm"
//         onClick={onClose}
//       />
      
//       <div className={`relative z-10 w-full max-w-sm rounded-xl ${styles.bg} border ${styles.border} p-6 shadow-2xl`}>
//         <button
//           onClick={onClose}
//           className="absolute right-3 top-3 text-gray-400 hover:text-white transition-colors"
//         >
//           <X size={20} />
//         </button>

//         <div className="text-center">
//           <div className="flex justify-center mb-4">
//             {styles.icon}
//           </div>
          
//           <h3 className={`text-xl font-bold mb-3 font-heading ${styles.titleColor}`}>
//             {title}
//           </h3>
          
//           <div className={`text-sm mb-6 font-body ${styles.textColor} whitespace-pre-line`}>
//             {message}
//           </div>
          
//           <div className="flex gap-3 justify-center">
//             {onConfirm && type === 'info' && (
//               <button
//                 onClick={onConfirm}
//                 className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition"
//               >
//                 Confirm
//               </button>
//             )}
//             <button
//               onClick={onClose}
//               className={`px-6 py-2 rounded-lg font-medium transition ${
//                 type === 'success' 
//                   ? 'bg-green-500 hover:bg-green-600 text-white'
//                   : type === 'error'
//                   ? 'bg-red-500 hover:bg-red-600 text-white'
//                   : 'bg-gray-700 hover:bg-gray-600 text-white'
//               }`}
//             >
//               {onConfirm ? 'Cancel' : 'OK'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Transfer = () => {
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);

//   const [balances, setBalances] = useState({
//     working: 0,
//     roi: 0,
//     aurum: 0,
//     energy: 0
//   });

//   const [fromWallet, setFromWallet] = useState('working');
//   const [toWallet, setToWallet] = useState('aurum');
//   const [amount, setAmount] = useState('');

//   // Transfer limits state
//   const [transferLimits, setTransferLimits] = useState({
//     dailyTransferCount: 0,
//     lastTransferDate: null,
//     dailyTransferAmount: 0,
//     maxDailyTransfers: 1,
//     maxDailyAmount: 1000,
//     minTransferAmount: 10
//   });

//   // Dialog state
//   const [dialog, setDialog] = useState({
//     isOpen: false,
//     title: '',
//     message: '',
//     type: 'info',
//     onConfirm: null
//   });

//   // Get user info from localStorage
//   const userId = localStorage.getItem('userId') || '';
//   const userName = localStorage.getItem('userName') || '';
//   const userEmail = localStorage.getItem('userEmail') || '';
//   const userDbKey = localStorage.getItem('dbKey') || '';
//   const userRegistrationDate = localStorage.getItem('registrationDate') || '';

//   // Format date to YYYY-MM-DD
//   const formatDate = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const day = String(d.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   const getTodayDate = () => {
//     return formatDate(new Date());
//   };

//   const resetDailyLimitsIfNewDay = () => {
//     const today = getTodayDate();
//     if (transferLimits.lastTransferDate !== today) {
//       setTransferLimits(prev => ({
//         ...prev,
//         dailyTransferCount: 0,
//         dailyTransferAmount: 0,
//         lastTransferDate: today
//       }));
//     }
//   };

//   // Show dialog function
//   const showDialog = (title, message, type = 'info', onConfirm = null) => {
//     setDialog({
//       isOpen: true,
//       title,
//       message,
//       type,
//       onConfirm
//     });
//   };

//   // Close dialog function
//   const closeDialog = () => {
//     setDialog({
//       isOpen: false,
//       title: '',
//       message: '',
//       type: 'info',
//       onConfirm: null
//     });
//   };

//   useEffect(() => {
//     if (!userId) {
//       showDialog('Error', 'User ID not found. Please login again.', 'error');
//       setLoading(false);
//       return;
//     }

//     loadBalances();
//     fetchTransferHistory();
//   }, [userId]);

//   const loadBalances = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       if (!userDbKey || !userRegistrationDate) {
//         showDialog('Error', 'User session data incomplete. Please login again.', 'error');
//         setLoading(false);
//         return;
//       }

//       // Get user data from date-wise structure: users/2026-02-06/dbKey
//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const userSnapshot = await get(userRef);
      
//       if (!userSnapshot.exists()) {
//         // Try to find user in any date folder
//         const usersRef = ref(database, 'users');
//         const allUsersSnapshot = await get(usersRef);
        
//         if (!allUsersSnapshot.exists()) {
//           showDialog('Error', 'No users found in database.', 'error');
//           setLoading(false);
//           return;
//         }

//         const allUsers = allUsersSnapshot.val();
//         let userFound = null;
//         let foundDate = null;

//         // Search through all date folders
//         for (const date in allUsers) {
//           if (typeof allUsers[date] === 'object') {
//             for (const [key, user] of Object.entries(allUsers[date])) {
//               if (user.sponsorId === userId || user.dbKey === userDbKey) {
//                 userFound = user;
//                 foundDate = date;
//                 break;
//               }
//             }
//             if (userFound) break;
//           }
//         }

//         if (!userFound) {
//           showDialog('Error', 'User record not found. Please check your login.', 'error');
//           setLoading(false);
//           return;
//         }

//         // Update localStorage with found date
//         localStorage.setItem('registrationDate', foundDate);
//         await loadUserWallets(userFound);
//       } else {
//         const userData = userSnapshot.val();
//         await loadUserWallets(userData);
//       }

//     } catch (err) {
//       console.error("Load balances error:", err);
//       showDialog('Error', 'Failed to load wallet balances. Please try again.', 'error');
//       setLoading(false);
//     }
//   };

//   const loadUserWallets = async (userData) => {
//     try {
//       const wallets = userData.wallets || {};
      
//       const working = Number(wallets.working || 0);
//       const roi = Number(wallets.roi || 0);
//       const aurum = Number(wallets.aurum || 0);
//       const energy = Number(wallets.energy || 0);

//       setBalances({ working, roi, aurum, energy });

//       const updates = {};
//       if (wallets.working === undefined) updates['wallets/working'] = working;
//       if (wallets.roi === undefined) updates['wallets/roi'] = roi;
//       if (wallets.aurum === undefined) updates['wallets/aurum'] = aurum;
//       if (wallets.energy === undefined) updates['wallets/energy'] = energy;

//       if (Object.keys(updates).length > 0) {
//         const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//         updates['updatedAt'] = new Date().toISOString();
//         await update(userRef, updates);
//       }

//     } catch (err) {
//       console.error("Load wallets error:", err);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTransferHistory = async () => {
//     try {
//       const today = getTodayDate();
      
//       const transfersRef = ref(database, 'Transfers');
//       const transfersSnapshot = await get(transfersRef);
      
//       let dailyCount = 0;
//       let dailyAmount = 0;
//       let lastDate = null;

//       if (transfersSnapshot.exists()) {
//         const allTransfers = transfersSnapshot.val();
        
//         Object.values(allTransfers).forEach(transfer => {
//           if (transfer && transfer.userId === userId) {
//             const transferDate = formatDate(new Date(transfer.timestamp));
            
//             if (transferDate === today) {
//               dailyCount++;
//               dailyAmount += parseFloat(transfer.amount) || 0;
//             }
            
//             if (!lastDate || transfer.timestamp > lastDate) {
//               lastDate = transferDate;
//             }
//           }
//         });
//       }

//       setTransferLimits(prev => ({
//         ...prev,
//         dailyTransferCount: dailyCount,
//         dailyTransferAmount: dailyAmount,
//         lastTransferDate: lastDate || today
//       }));

//     } catch (error) {
//       console.error('Error fetching transfer history:', error);
//     }
//   };

//   const generateTransferId = () => {
//     const timestamp = Date.now().toString(36).toUpperCase();
//     const random = Math.random().toString(36).substr(2, 5).toUpperCase();
//     return `T${timestamp}${random}`;
//   };

//   const saveTransferToFirebase = async (transferData) => {
//     try {
//       const today = getTodayDate();
//       const transferId = generateTransferId();
      
//       // Create transfer record
//       const transferRecord = {
//         id: transferId,
//         userId: userId,
//         userName: userName,
//         fromWallet: transferData.fromWallet,
//         toWallet: transferData.toWallet,
//         amount: transferData.amount,
//         date: new Date().toISOString(),
//         status: 'completed',
//         timestamp: Date.now(),
//         userEmail: userEmail,
//         previousFromBalance: balances[transferData.fromWallet],
//         previousToBalance: balances[transferData.toWallet],
//         newFromBalance: balances[transferData.fromWallet] - transferData.amount,
//         newToBalance: balances[transferData.toWallet] + transferData.amount,
//         transferDate: today,
//         dailyTransferCount: transferLimits.dailyTransferCount + 1,
//         dailyTransferAmount: transferLimits.dailyTransferAmount + transferData.amount,
//         userDbKey: userDbKey,
//         userRegistrationDate: userRegistrationDate
//       };

//       // Save transfer with date-wise structure: Transfers/2026-02-06/userId/transferId
//       const transfersRef = ref(database, `Transfers/${today}/${userId}/${transferId}`);
//       await set(transfersRef, transferRecord);
      
//       console.log('Transfer saved to Firebase with date-wise structure:', today, transferId);
      
//       return transferRecord;
//     } catch (error) {
//       console.error("Error saving transfer to Firebase:", error);
//       throw error;
//     }
//   };

//   const handleTransferValidation = () => {
//     const today = getTodayDate();
//     const value = Number(amount);
    
//     // Reset limits if new day
//     if (transferLimits.lastTransferDate !== today) {
//       resetDailyLimitsIfNewDay();
//     }

//     // Validation
//     if (!value || value <= 0) {
//       showDialog('Validation Error', 'Please enter a valid amount greater than 0.', 'error');
//       return false;
//     }
    
//     if (value < transferLimits.minTransferAmount) {
//       showDialog('Validation Error', `Minimum transfer amount is $${transferLimits.minTransferAmount}.`, 'error');
//       return false;
//     }
    
//     if (value > balances[fromWallet]) {
//       showDialog('Insufficient Balance', `Insufficient balance in ${getWalletLabel(fromWallet)}.`, 'error');
//       return false;
//     }
    
//     // Check daily transfer count (only 1 transfer per day)
//     if (transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers) {
//       showDialog('Daily Limit Reached', `Daily transfer limit reached. You can only make ${transferLimits.maxDailyTransfers} transfer per day. Please try again tomorrow.`, 'error');
//       return false;
//     }
    
//     // Check daily amount limit
//     const projectedDailyAmount = transferLimits.dailyTransferAmount + value;
//     if (projectedDailyAmount > transferLimits.maxDailyAmount) {
//       showDialog('Daily Limit Exceeded', `Daily transfer limit is $${transferLimits.maxDailyAmount}. You've already transferred $${transferLimits.dailyTransferAmount.toFixed(2)} today.`, 'error');
//       return false;
//     }
    
//     if (fromWallet === toWallet) {
//       showDialog('Invalid Transfer', 'Cannot transfer to the same wallet.', 'error');
//       return false;
//     }

//     return true;
//   };

//   const confirmTransfer = async () => {
//     const today = getTodayDate();
//     const value = Number(amount);
    
//     setSaving(true);
//     setError(null);

//     try {
//       if (!userDbKey || !userRegistrationDate) {
//         throw new Error("User session expired. Please login again.");
//       }

//       const newFromBalance = balances[fromWallet] - value;
//       const newToBalance = balances[toWallet] + value;

//       // Update user wallet balances
//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const updates = {
//         [`wallets/${fromWallet}`]: newFromBalance,
//         [`wallets/${toWallet}`]: newToBalance,
//         'updatedAt': new Date().toISOString()
//       };

//       await saveTransferToFirebase({
//         fromWallet,
//         toWallet,
//         amount: value
//       });

//       await update(userRef, updates);

//       const newDailyCount = transferLimits.dailyTransferCount + 1;
//       const newDailyAmount = transferLimits.dailyTransferAmount + value;
      
//       setTransferLimits(prev => ({
//         ...prev,
//         dailyTransferCount: newDailyCount,
//         dailyTransferAmount: newDailyAmount,
//         lastTransferDate: today
//       }));

//       setBalances({
//         ...balances,
//         [fromWallet]: newFromBalance,
//         [toWallet]: newToBalance
//       });

//       // Show success dialog
//       showDialog(
//         'Transfer Successful',
//         `✅ Transfer Completed!\n\n$${value.toFixed(2)} transferred from ${getWalletLabel(fromWallet)} to ${getWalletLabel(toWallet)}\n\nDaily transfers: ${newDailyCount}/${transferLimits.maxDailyTransfers}\nDaily amount: $${newDailyAmount.toFixed(2)}/$${transferLimits.maxDailyAmount}`,
//         'success'
//       );
      
//       setAmount('');
      
//     } catch (err) {
//       console.error("Transfer error:", err);
//       showDialog('Transfer Failed', 'Transfer failed. Please try again.', 'error');
      
//       await loadBalances();
//       await fetchTransferHistory();
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleTransfer = async () => {
//     if (!handleTransferValidation()) {
//       return;
//     }

//     const value = Number(amount);
    
//     // Show confirmation dialog
//     showDialog(
//       'Confirm Transfer',
//       `Transfer Details:\n\nFrom: ${getWalletLabel(fromWallet)}\nTo: ${getWalletLabel(toWallet)}\nAmount: $${value.toFixed(2)}\n\nDaily transfers used: ${transferLimits.dailyTransferCount}/${transferLimits.maxDailyTransfers}\nDaily amount: $${(transferLimits.dailyTransferAmount + value).toFixed(2)}/$${transferLimits.maxDailyAmount}\n\nProceed with transfer?`,
//       'info',
//       confirmTransfer
//     );
//   };

//   const getWalletLabel = (key) => {
//     const map = {
//       working: "AV Power Wallet",
//       roi: "AV ROI Wallet",
//       aurum: "Aerovolt Wallet",
//       energy: "AV Energy Wallet"
//     };
//     return map[key] || key.charAt(0).toUpperCase() + key.slice(1);
//   };

//   const getWalletIcon = (key) => {
//     switch(key) {
//       case 'working': return '💰';
//       case 'roi': return '📈';
//       case 'aurum': return '🪙';
//       case 'energy': return '⚡';
//       default: return '💳';
//     }
//   };

//   const getWalletColor = (key) => {
//     switch(key) {
//       case 'working': return 'from-blue-950/30 to-card border-blue-600/30';
//       case 'roi': return 'from-emerald-950/30 to-card border-emerald-600/30';
//       case 'aurum': return 'from-amber-950/30 to-card border-amber-600/30';
//       case 'energy': return 'from-yellow-950/30 to-card border-yellow-600/30';
//       default: return 'from-card to-card border-border';
//     }
//   };

//   const fromWalletOptions = ['working', 'roi', 'energy'];
//   const toWalletOptions = ['aurum'];

//   if (loading) {
//     return (
//       <div className="flex flex-col items-center justify-center min-h-[60vh]">
//         <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
//         <p className="text-muted-foreground">Loading wallet balances...</p>
//       </div>
//     );
//   }

//   const isSubmitDisabled = 
//     saving || 
//     !amount || 
//     Number(amount) < transferLimits.minTransferAmount || 
//     Number(amount) > balances[fromWallet] ||
//     transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers ||
//     (transferLimits.dailyTransferAmount + Number(amount || 0)) > transferLimits.maxDailyAmount;

//   return (
//     <div className="max-w-4xl mx-auto pt-16 md:pt-20 px-4 pb-12">
//       {/* Transfer Dialog */}
//       <TransferDialog
//         isOpen={dialog.isOpen}
//         onClose={closeDialog}
//         title={dialog.title}
//         message={dialog.message}
//         type={dialog.type}
//         onConfirm={dialog.onConfirm}
//       />

//       <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">Transfer Funds</h1>
//       <p className="text-primary mb-6">Move balance between your wallets</p>

//       {/* Daily Transfer Limits */}
//       <div className="mb-8 p-5 rounded-2xl bg-gradient-to-r from-indigo-950/40 to-purple-950/40 border border-indigo-600/30">
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-3">
//             <Shield className="h-6 w-6 text-indigo-400" />
//             <h3 className="text-lg font-semibold text-foreground">Daily Transfer Limits</h3>
//           </div>
//           <div className="text-sm text-indigo-300">
//             Resets daily at midnight
//           </div>
//         </div>
        
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div className="bg-black/30 p-4 rounded-xl">
//             <div className="flex items-center gap-2 mb-2">
//               <Clock className="h-4 w-4 text-blue-400" />
//               <span className="text-sm text-muted-foreground">Transfers Today</span>
//             </div>
//             <div className="text-2xl font-bold text-blue-300">
//               {transferLimits.dailyTransferCount} / {transferLimits.maxDailyTransfers}
//             </div>
//             <div className="text-xs text-muted-foreground mt-1">
//               {transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers 
//                 ? 'Limit reached' 
//                 : `${transferLimits.maxDailyTransfers - transferLimits.dailyTransferCount} remaining`}
//             </div>
//           </div>
          
//           <div className="bg-black/30 p-4 rounded-xl">
//             <div className="flex items-center gap-2 mb-2">
//               <DollarSign className="h-4 w-4 text-emerald-400" />
//               <span className="text-sm text-muted-foreground">Amount Today</span>
//             </div>
//             <div className="text-2xl font-bold text-emerald-300">
//               ${transferLimits.dailyTransferAmount.toFixed(2)} / ${transferLimits.maxDailyAmount}
//             </div>
//             <div className="text-xs text-muted-foreground mt-1">
//               ${(transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount).toFixed(2)} remaining
//             </div>
//           </div>
          
//           <div className="bg-black/30 p-4 rounded-xl">
//             <div className="flex items-center gap-2 mb-2">
//               <AlertTriangle className="h-4 w-4 text-amber-400" />
//               <span className="text-sm text-muted-foreground">Minimum Transfer</span>
//             </div>
//             <div className="text-2xl font-bold text-amber-300">
//               ${transferLimits.minTransferAmount}
//             </div>
//             <div className="text-xs text-muted-foreground mt-1">
//               per transfer
//             </div>
//           </div>
//         </div>
        
//         {transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers && (
//           <div className="mt-4 p-3 bg-red-900/20 border border-red-700/40 rounded-lg flex items-center gap-3">
//             <AlertCircle className="h-5 w-5 text-red-400" />
//             <span className="text-red-300 text-sm">
//               Daily transfer limit reached. Please try again tomorrow.
//             </span>
//           </div>
//         )}
//       </div>

//       {/* User Info */}
//       <div className="mb-6 p-4 glass rounded-xl border-border">
//         <div className="flex items-center gap-4">
//           <div className="icon-electric">
//             <Wallet className="h-6 w-6 text-primary" />
//           </div>
//           <div>
//             <p className="text-muted-foreground text-sm">Transferring as</p>
//             <p className="text-foreground font-medium">{userName} (ID: {userId})</p>
//             <p className="text-xs text-muted-foreground mt-1">
//               Registration: {userRegistrationDate}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Balances */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-10">
//         {Object.entries(balances).map(([key, val]) => (
//           <div
//             key={key}
//             className={`card-glow p-4 rounded-2xl ${getWalletColor(key)}`}
//           >
//             <div className="flex items-center justify-between mb-2">
//               <p className="text-primary text-sm font-medium">{getWalletLabel(key)}</p>
//               <span className="text-lg">{getWalletIcon(key)}</span>
//             </div>
//             <p className="text-2xl font-bold text-foreground">${val.toFixed(2)}</p>
//             {key === 'energy' && (
//               <p className="text-xs text-yellow-400 mt-1">From direct referrals</p>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Transfer Card */}
//       <div className="card-glow rounded-2xl p-6 md:p-8 shadow-2xl bg-card">
//         <div className="grid md:grid-cols-3 gap-6 md:gap-8">
//           {/* From */}
//           <div>
//             <label className="block text-primary font-medium mb-3">From Wallet</label>
//             <div className="space-y-3">
//               {fromWalletOptions.map((w) => (
//                 <button
//                   key={w}
//                   type="button"
//                   onClick={() => setFromWallet(w)}
//                   className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
//                     fromWallet === w
//                       ? 'border-primary bg-primary/10'
//                       : 'border-border hover:border-primary/60 bg-card'
//                   }`}
//                 >
//                   <div className="font-medium text-foreground flex items-center justify-between">
//                     <span>{getWalletLabel(w)}</span>
//                     <span>{getWalletIcon(w)}</span>
//                   </div>
//                   <div className="text-sm text-primary mt-1">${balances[w].toFixed(2)}</div>
//                   {w === 'energy' && (
//                     <div className="text-xs text-yellow-400 mt-1">Direct referral bonus</div>
//                   )}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Amount */}
//           <div>
//             <label className="block text-primary font-medium mb-3">
//               Amount (Min: ${transferLimits.minTransferAmount})
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 step="0.01"
//                 min={transferLimits.minTransferAmount}
//                 max={Math.min(balances[fromWallet], transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount)}
//                 value={amount}
//                 onChange={(e) => setAmount(e.target.value)}
//                 placeholder="0.00"
//                 className="w-full bg-background border border-border rounded-xl px-5 py-6 text-3xl font-bold text-center text-foreground focus:outline-none focus:border-primary focus:ring-1 focus:ring-ring"
//               />
//               <div className="absolute right-4 top-1/2 -translate-y-1/2 text-primary font-medium">
//                 USD
//               </div>
//             </div>

//             <div className="flex flex-wrap gap-2 mt-4">
//               {[10, 25, 50, 100].map((v) => (
//                 <button
//                   key={v}
//                   type="button"
//                   onClick={() => setAmount(v.toString())}
//                   className="px-4 py-2 bg-primary/10 hover:bg-primary/20 border border-primary/30 rounded-lg text-sm text-primary transition"
//                 >
//                   ${v}
//                 </button>
//               ))}
//               <button
//                 type="button"
//                 onClick={() => {
//                   const maxAllowed = Math.min(
//                     balances[fromWallet],
//                     transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount
//                   );
//                   setAmount(maxAllowed.toFixed(2));
//                 }}
//                 className="px-4 py-2 bg-emerald-900/30 hover:bg-emerald-800/40 border border-emerald-700/40 rounded-lg text-sm text-emerald-300 transition"
//               >
//                 MAX
//               </button>
//             </div>
            
//             {/* Validation messages */}
//             {amount && Number(amount) < transferLimits.minTransferAmount && (
//               <div className="mt-2 text-sm text-red-400 flex items-center gap-2">
//                 <AlertCircle className="h-4 w-4" />
//                 Minimum amount is ${transferLimits.minTransferAmount}
//               </div>
//             )}
//             {amount && (Number(amount) + transferLimits.dailyTransferAmount) > transferLimits.maxDailyAmount && (
//               <div className="mt-2 text-sm text-red-400 flex items-center gap-2">
//                 <AlertCircle className="h-4 w-4" />
//                 Would exceed daily limit of ${transferLimits.maxDailyAmount}
//               </div>
//             )}
//           </div>

//           {/* To */}
//           <div>
//             <label className="block text-primary font-medium mb-3">To Wallet</label>
//             <div className="space-y-3">
//               {toWalletOptions.map((w) => (
//                 <button
//                   key={w}
//                   type="button"
//                   onClick={() => setToWallet(w)}
//                   className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
//                     toWallet === w
//                       ? 'border-primary bg-primary/10'
//                       : 'border-border hover:border-primary/60 bg-card'
//                   }`}
//                 >
//                   <div className="font-medium text-foreground flex items-center justify-between">
//                     <span>{getWalletLabel(w)}</span>
//                     <span>{getWalletIcon(w)}</span>
//                   </div>
//                   <div className="text-sm text-primary mt-1">${balances[w].toFixed(2)}</div>
//                   <div className="text-xs text-muted-foreground mt-1">For package purchases</div>
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Summary & Button */}
//         <div className="mt-10 pt-8 border-t border-border">
//           <div className="bg-background/60 rounded-xl p-6 mb-6">
//             <div className="grid md:grid-cols-2 gap-6 text-sm">
//               <div>
//                 <div className="text-primary mb-1">Transferring from</div>
//                 <div className="font-medium text-foreground flex items-center gap-2">
//                   <span>{getWalletIcon(fromWallet)}</span>
//                   <span>{getWalletLabel(fromWallet)}</span>
//                 </div>
//               </div>
//               <div>
//                 <div className="text-primary mb-1">To</div>
//                 <div className="font-medium text-foreground flex items-center gap-2">
//                   <span>{getWalletIcon(toWallet)}</span>
//                   <span>{getWalletLabel(toWallet)}</span>
//                 </div>
//               </div>
//               <div>
//                 <div className="text-primary mb-1">Amount</div>
//                 <div className="text-2xl font-bold text-foreground">
//                   {amount ? `$${Number(amount).toFixed(2)}` : '—'}
//                 </div>
//               </div>
//               <div>
//                 <div className="text-primary mb-1">New {getWalletLabel(toWallet)} balance</div>
//                 <div className="text-xl font-bold text-emerald-400">
//                   ${(balances[toWallet] + Number(amount || 0)).toFixed(2)}
//                 </div>
//               </div>
//             </div>
            
//             {/* Daily limits summary */}
//             {amount && Number(amount) >= transferLimits.minTransferAmount && (
//               <div className="mt-6 pt-6 border-t border-border/30">
//                 <div className="text-sm text-muted-foreground mb-2">Daily Limits Summary</div>
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <div className="text-xs text-blue-300">Transfers Today</div>
//                     <div className="font-medium">
//                       {transferLimits.dailyTransferCount} → {transferLimits.dailyTransferCount + 1} / {transferLimits.maxDailyTransfers}
//                     </div>
//                   </div>
//                   <div>
//                     <div className="text-xs text-emerald-300">Amount Today</div>
//                     <div className="font-medium">
//                       ${transferLimits.dailyTransferAmount.toFixed(2)} → ${(transferLimits.dailyTransferAmount + Number(amount)).toFixed(2)} / ${transferLimits.maxDailyAmount}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           <div className="flex flex-col md:flex-row gap-4 justify-center">
//             <button
//               onClick={handleTransfer}
//               disabled={isSubmitDisabled}
//               className="btn-electric disabled:opacity-50 disabled:cursor-not-allowed py-4 px-12 rounded-xl text-lg transition shadow-lg flex items-center justify-center gap-3 min-w-[240px]"
//             >
//               {saving ? (
//                 <>
//                   <Loader2 className="h-5 w-5 animate-spin" />
//                   Processing...
//                 </>
//               ) : (
//                 <>
//                   <ArrowRightLeft className="h-5 w-5" />
//                   Confirm Transfer
//                 </>
//               )}
//             </button>

//             <button
//               onClick={() => {
//                 setAmount('');
//                 setFromWallet('working');
//                 setToWallet('aurum');
//               }}
//               className="border border-border hover:bg-primary/5 text-foreground px-10 py-4 rounded-xl transition"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>

//         {error && (
//           <div className="mt-6 p-4 bg-destructive/10 border border-destructive/30 rounded-xl text-destructive-foreground text-center">
//             {error}
//           </div>
//         )}
//       </div>

//       {/* Rules with limits */}
//       <div className="mt-12 glass rounded-2xl p-6 border-border">
//         <div className="flex items-center gap-3 mb-4">
//           <AlertCircle className="text-primary" />
//           <h3 className="text-lg font-semibold text-foreground">Transfer Rules & Limits</h3>
//         </div>
//         <ul className="space-y-2 text-muted-foreground text-sm">
//           <li className="flex items-center gap-2">
//             <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
//             <span>Transfer from: <strong className="text-foreground">AV Power</strong>, <strong className="text-foreground">AV ROI</strong>, or <strong className="text-foreground">AV Energy</strong> wallet</span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
//             <span>Destination wallet: <strong className="text-foreground">Aerovolt Wallet</strong> only</span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
//             <span>Maximum <strong className="text-blue-300">1 transfer</strong> allowed per day</span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
//             <span>Daily transfer limit: <strong className="text-emerald-300">${transferLimits.maxDailyAmount}</strong></span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
//             <span>Minimum transfer: <strong className="text-amber-300">${transferLimits.minTransferAmount}</strong></span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
//             <span>Transfers are saved in: <code className="text-xs bg-black/30 px-1 py-0.5 rounded">Transfers/YYYY-MM-DD/userId/transferId</code></span>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Transfer;


// import React, { useState, useEffect } from 'react';
// import { database, ref, get, update, set } from '../../firebase';
// import { Wallet, ArrowRightLeft, AlertCircle, CheckCircle2, Loader2, Clock, Shield, DollarSign, AlertTriangle, X, Ban } from 'lucide-react';

// // Dialog Component for Transfer
// const TransferDialog = ({ isOpen, onClose, title, message, type = 'info', onConfirm }) => {
//   if (!isOpen) return null;

//   const getDialogStyles = () => {
//     const bgColor = '#132131';
    
//     switch (type) {
//       case 'success':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-green-500/30',
//           icon: <CheckCircle2 className="text-green-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       case 'error':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-red-500/30',
//           icon: <AlertCircle className="text-red-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       case 'warning':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-yellow-500/30',
//           icon: <AlertTriangle className="text-yellow-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       case 'blocked':
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-red-500/30',
//           icon: <Ban className="text-red-500" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//       default:
//         return {
//           bg: 'bg-[#132131]',
//           border: 'border-primary/30',
//           icon: <AlertCircle className="text-blue-400" size={40} />,
//           titleColor: 'text-white',
//           textColor: 'text-gray-200'
//         };
//     }
//   };

//   const styles = getDialogStyles();

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <div 
//         className="absolute inset-0 bg-black/70 backdrop-blur-sm"
//         onClick={onClose}
//       />
      
//       <div className={`relative z-10 w-full max-w-sm rounded-xl ${styles.bg} border ${styles.border} p-6 shadow-2xl`}>
//         <button
//           onClick={onClose}
//           className="absolute right-3 top-3 text-gray-400 hover:text-white transition-colors"
//         >
//           <X size={20} />
//         </button>

//         <div className="text-center">
//           <div className="flex justify-center mb-4">
//             {styles.icon}
//           </div>
          
//           <h3 className={`text-xl font-bold mb-3 font-heading ${styles.titleColor}`}>
//             {title}
//           </h3>
          
//           <div className={`text-sm mb-6 font-body ${styles.textColor} whitespace-pre-line`}>
//             {message}
//           </div>
          
//           <div className="flex gap-3 justify-center">
//             {onConfirm && type === 'info' && (
//               <button
//                 onClick={onConfirm}
//                 className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition"
//               >
//                 Confirm
//               </button>
//             )}
//             <button
//               onClick={onClose}
//               className={`px-6 py-2 rounded-lg font-medium transition ${
//                 type === 'success' 
//                   ? 'bg-green-500 hover:bg-green-600 text-white'
//                   : type === 'error'
//                   ? 'bg-red-500 hover:bg-red-600 text-white'
//                   : type === 'blocked'
//                   ? 'bg-red-600 hover:bg-red-700 text-white'
//                   : 'bg-gray-700 hover:bg-gray-600 text-white'
//               }`}
//             >
//               {onConfirm ? 'Cancel' : 'OK'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Transfer = () => {
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);

//   const [balances, setBalances] = useState({
//     working: 0,
//     roi: 0,
//     aurum: 0,
//     energy: 0
//   });

//   const [fromWallet, setFromWallet] = useState('working');
//   const [toWallet, setToWallet] = useState('aurum');
//   const [amount, setAmount] = useState('');

//   // Transfer limits state
//   const [transferLimits, setTransferLimits] = useState({
//     dailyTransferCount: 0,
//     lastTransferDate: null,
//     dailyTransferAmount: 0,
//     maxDailyTransfers: 1,
//     maxDailyAmount: 1000,
//     minTransferAmount: 10
//   });

//   // User transfer status
//   const [userTransferStatus, setUserTransferStatus] = useState({
//     internalTransferStatus: 'open', // 'open' or 'blocked'
//     isTransferAllowed: true
//   });

//   // Dialog state
//   const [dialog, setDialog] = useState({
//     isOpen: false,
//     title: '',
//     message: '',
//     type: 'info',
//     onConfirm: null
//   });

//   // Get user info from localStorage
//   const userId = localStorage.getItem('userId') || '';
//   const userName = localStorage.getItem('userName') || '';
//   const userEmail = localStorage.getItem('userEmail') || '';
//   const userDbKey = localStorage.getItem('dbKey') || '';
//   const userRegistrationDate = localStorage.getItem('registrationDate') || '';

//   // Format date to YYYY-MM-DD
//   const formatDate = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const day = String(d.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   const getTodayDate = () => {
//     return formatDate(new Date());
//   };

//   const resetDailyLimitsIfNewDay = () => {
//     const today = getTodayDate();
//     if (transferLimits.lastTransferDate !== today) {
//       setTransferLimits(prev => ({
//         ...prev,
//         dailyTransferCount: 0,
//         dailyTransferAmount: 0,
//         lastTransferDate: today
//       }));
//     }
//   };

//   // Show dialog function
//   const showDialog = (title, message, type = 'info', onConfirm = null) => {
//     setDialog({
//       isOpen: true,
//       title,
//       message,
//       type,
//       onConfirm
//     });
//   };

//   // Close dialog function
//   const closeDialog = () => {
//     setDialog({
//       isOpen: false,
//       title: '',
//       message: '',
//       type: 'info',
//       onConfirm: null
//     });
//   };

//   // Check user transfer status
//   const checkUserTransferStatus = (userData) => {
//     const internalTransferStatus = userData.internalTransferStatus || 'open';
//     const isTransferAllowed = internalTransferStatus !== 'blocked';
    
//     setUserTransferStatus({
//       internalTransferStatus,
//       isTransferAllowed
//     });

//     // If transfer is blocked, show blocked dialog immediately
//     if (internalTransferStatus === 'blocked') {
//       showDialog(
//         'Transfer Blocked',
//         'Your account transfer functionality has been temporarily disabled. Please contact support for assistance.',
//         'blocked'
//       );
//     }

//     return isTransferAllowed;
//   };

//   useEffect(() => {
//     if (!userId) {
//       showDialog('Error', 'User ID not found. Please login again.', 'error');
//       setLoading(false);
//       return;
//     }

//     loadUserData();
//   }, [userId]);

//   const loadUserData = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       if (!userDbKey || !userRegistrationDate) {
//         showDialog('Error', 'User session data incomplete. Please login again.', 'error');
//         setLoading(false);
//         return;
//       }

//       // Get user data from date-wise structure: users/2026-02-06/dbKey
//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const userSnapshot = await get(userRef);
      
//       if (!userSnapshot.exists()) {
//         // Try to find user in any date folder
//         const usersRef = ref(database, 'users');
//         const allUsersSnapshot = await get(usersRef);
        
//         if (!allUsersSnapshot.exists()) {
//           showDialog('Error', 'No users found in database.', 'error');
//           setLoading(false);
//           return;
//         }

//         const allUsers = allUsersSnapshot.val();
//         let userFound = null;
//         let foundDate = null;

//         // Search through all date folders
//         for (const date in allUsers) {
//           if (typeof allUsers[date] === 'object') {
//             for (const [key, user] of Object.entries(allUsers[date])) {
//               if (user.sponsorId === userId || user.dbKey === userDbKey) {
//                 userFound = user;
//                 foundDate = date;
//                 break;
//               }
//             }
//             if (userFound) break;
//           }
//         }

//         if (!userFound) {
//           showDialog('Error', 'User record not found. Please check your login.', 'error');
//           setLoading(false);
//           return;
//         }

//         // Update localStorage with found date
//         localStorage.setItem('registrationDate', foundDate);
//         await loadUserWallets(userFound);
//         checkUserTransferStatus(userFound);
//       } else {
//         const userData = userSnapshot.val();
//         await loadUserWallets(userData);
//         checkUserTransferStatus(userData);
//       }

//     } catch (err) {
//       console.error("Load user data error:", err);
//       showDialog('Error', 'Failed to load user data. Please try again.', 'error');
//       setLoading(false);
//     }
//   };

//   const loadUserWallets = async (userData) => {
//     try {
//       const wallets = userData.wallets || {};
      
//       const working = Number(wallets.working || 0);
//       const roi = Number(wallets.roi || 0);
//       const aurum = Number(wallets.aurum || 0);
//       const energy = Number(wallets.energy || 0);

//       setBalances({ working, roi, aurum, energy });

//       const updates = {};
//       if (wallets.working === undefined) updates['wallets/working'] = working;
//       if (wallets.roi === undefined) updates['wallets/roi'] = roi;
//       if (wallets.aurum === undefined) updates['wallets/aurum'] = aurum;
//       if (wallets.energy === undefined) updates['wallets/energy'] = energy;

//       if (Object.keys(updates).length > 0) {
//         const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//         updates['updatedAt'] = new Date().toISOString();
//         await update(userRef, updates);
//       }

//     } catch (err) {
//       console.error("Load wallets error:", err);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTransferHistory = async () => {
//     try {
//       const today = getTodayDate();
      
//       const transfersRef = ref(database, 'Transfers');
//       const transfersSnapshot = await get(transfersRef);
      
//       let dailyCount = 0;
//       let dailyAmount = 0;
//       let lastDate = null;

//       if (transfersSnapshot.exists()) {
//         const allTransfers = transfersSnapshot.val();
        
//         Object.values(allTransfers).forEach(transfer => {
//           if (transfer && transfer.userId === userId) {
//             const transferDate = formatDate(new Date(transfer.timestamp));
            
//             if (transferDate === today) {
//               dailyCount++;
//               dailyAmount += parseFloat(transfer.amount) || 0;
//             }
            
//             if (!lastDate || transfer.timestamp > lastDate) {
//               lastDate = transferDate;
//             }
//           }
//         });
//       }

//       setTransferLimits(prev => ({
//         ...prev,
//         dailyTransferCount: dailyCount,
//         dailyTransferAmount: dailyAmount,
//         lastTransferDate: lastDate || today
//       }));

//     } catch (error) {
//       console.error('Error fetching transfer history:', error);
//     }
//   };

//   const generateTransferId = () => {
//     const timestamp = Date.now().toString(36).toUpperCase();
//     const random = Math.random().toString(36).substr(2, 5).toUpperCase();
//     return `T${timestamp}${random}`;
//   };

//   const saveTransferToFirebase = async (transferData) => {
//     try {
//       const today = getTodayDate();
//       const transferId = generateTransferId();
      
//       // Create transfer record
//       const transferRecord = {
//         id: transferId,
//         userId: userId,
//         userName: userName,
//         fromWallet: transferData.fromWallet,
//         toWallet: transferData.toWallet,
//         amount: transferData.amount,
//         date: new Date().toISOString(),
//         status: 'completed',
//         timestamp: Date.now(),
//         userEmail: userEmail,
//         previousFromBalance: balances[transferData.fromWallet],
//         previousToBalance: balances[transferData.toWallet],
//         newFromBalance: balances[transferData.fromWallet] - transferData.amount,
//         newToBalance: balances[transferData.toWallet] + transferData.amount,
//         transferDate: today,
//         dailyTransferCount: transferLimits.dailyTransferCount + 1,
//         dailyTransferAmount: transferLimits.dailyTransferAmount + transferData.amount,
//         userDbKey: userDbKey,
//         userRegistrationDate: userRegistrationDate
//       };

//       // Save transfer with date-wise structure: Transfers/2026-02-06/userId/transferId
//       const transfersRef = ref(database, `Transfers/${today}/${userId}/${transferId}`);
//       await set(transfersRef, transferRecord);
      
//       console.log('Transfer saved to Firebase with date-wise structure:', today, transferId);
      
//       return transferRecord;
//     } catch (error) {
//       console.error("Error saving transfer to Firebase:", error);
//       throw error;
//     }
//   };

//   const handleTransferValidation = () => {
//     // First check if user is allowed to transfer
//     if (!userTransferStatus.isTransferAllowed) {
//       showDialog(
//         'Transfer Blocked',
//         'Your account transfer functionality has been temporarily disabled. Please contact support for assistance.',
//         'blocked'
//       );
//       return false;
//     }

//     const today = getTodayDate();
//     const value = Number(amount);
    
//     // Reset limits if new day
//     if (transferLimits.lastTransferDate !== today) {
//       resetDailyLimitsIfNewDay();
//     }

//     // Validation
//     if (!value || value <= 0) {
//       showDialog('Validation Error', 'Please enter a valid amount greater than 0.', 'error');
//       return false;
//     }
    
//     if (value < transferLimits.minTransferAmount) {
//       showDialog('Validation Error', `Minimum transfer amount is $${transferLimits.minTransferAmount}.`, 'error');
//       return false;
//     }
    
//     if (value > balances[fromWallet]) {
//       showDialog('Insufficient Balance', `Insufficient balance in ${getWalletLabel(fromWallet)}.`, 'error');
//       return false;
//     }
    
//     // Check daily transfer count (only 1 transfer per day)
//     if (transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers) {
//       showDialog('Daily Limit Reached', `Daily transfer limit reached. You can only make ${transferLimits.maxDailyTransfers} transfer per day. Please try again tomorrow.`, 'error');
//       return false;
//     }
    
//     // Check daily amount limit
//     const projectedDailyAmount = transferLimits.dailyTransferAmount + value;
//     if (projectedDailyAmount > transferLimits.maxDailyAmount) {
//       showDialog('Daily Limit Exceeded', `Daily transfer limit is $${transferLimits.maxDailyAmount}. You've already transferred $${transferLimits.dailyTransferAmount.toFixed(2)} today.`, 'error');
//       return false;
//     }
    
//     if (fromWallet === toWallet) {
//       showDialog('Invalid Transfer', 'Cannot transfer to the same wallet.', 'error');
//       return false;
//     }

//     return true;
//   };

//   const confirmTransfer = async () => {
//     const today = getTodayDate();
//     const value = Number(amount);
    
//     setSaving(true);
//     setError(null);

//     try {
//       if (!userDbKey || !userRegistrationDate) {
//         throw new Error("User session expired. Please login again.");
//       }

//       const newFromBalance = balances[fromWallet] - value;
//       const newToBalance = balances[toWallet] + value;

//       // Update user wallet balances
//       const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
//       const updates = {
//         [`wallets/${fromWallet}`]: newFromBalance,
//         [`wallets/${toWallet}`]: newToBalance,
//         'updatedAt': new Date().toISOString()
//       };

//       await saveTransferToFirebase({
//         fromWallet,
//         toWallet,
//         amount: value
//       });

//       await update(userRef, updates);

//       const newDailyCount = transferLimits.dailyTransferCount + 1;
//       const newDailyAmount = transferLimits.dailyTransferAmount + value;
      
//       setTransferLimits(prev => ({
//         ...prev,
//         dailyTransferCount: newDailyCount,
//         dailyTransferAmount: newDailyAmount,
//         lastTransferDate: today
//       }));

//       setBalances({
//         ...balances,
//         [fromWallet]: newFromBalance,
//         [toWallet]: newToBalance
//       });

//       // Show success dialog
//       showDialog(
//         'Transfer Successful',
//         `✅ Transfer Completed!\n\n$${value.toFixed(2)} transferred from ${getWalletLabel(fromWallet)} to ${getWalletLabel(toWallet)}\n\nDaily transfers: ${newDailyCount}/${transferLimits.maxDailyTransfers}\nDaily amount: $${newDailyAmount.toFixed(2)}/$${transferLimits.maxDailyAmount}`,
//         'success'
//       );
      
//       setAmount('');
      
//     } catch (err) {
//       console.error("Transfer error:", err);
//       showDialog('Transfer Failed', 'Transfer failed. Please try again.', 'error');
      
//       await loadUserData();
//       await fetchTransferHistory();
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleTransfer = async () => {
//     if (!handleTransferValidation()) {
//       return;
//     }

//     const value = Number(amount);
    
//     // Show confirmation dialog
//     showDialog(
//       'Confirm Transfer',
//       `Transfer Details:\n\nFrom: ${getWalletLabel(fromWallet)}\nTo: ${getWalletLabel(toWallet)}\nAmount: $${value.toFixed(2)}\n\nDaily transfers used: ${transferLimits.dailyTransferCount}/${transferLimits.maxDailyTransfers}\nDaily amount: $${(transferLimits.dailyTransferAmount + value).toFixed(2)}/$${transferLimits.maxDailyAmount}\n\nProceed with transfer?`,
//       'info',
//       confirmTransfer
//     );
//   };

//   const getWalletLabel = (key) => {
//     const map = {
//       working: "AV Power Wallet",
//       roi: "AV ROI Wallet",
//       aurum: "Aerovolt Wallet",
//       energy: "AV Energy Wallet"
//     };
//     return map[key] || key.charAt(0).toUpperCase() + key.slice(1);
//   };

//   const getWalletIcon = (key) => {
//     switch(key) {
//       case 'working': return '💰';
//       case 'roi': return '📈';
//       case 'aurum': return '🪙';
//       case 'energy': return '⚡';
//       default: return '💳';
//     }
//   };

//   const getWalletColor = (key) => {
//     switch(key) {
//       case 'working': return 'from-blue-950/30 to-card border-blue-600/30';
//       case 'roi': return 'from-emerald-950/30 to-card border-emerald-600/30';
//       case 'aurum': return 'from-amber-950/30 to-card border-amber-600/30';
//       case 'energy': return 'from-yellow-950/30 to-card border-yellow-600/30';
//       default: return 'from-card to-card border-border';
//     }
//   };

//   const fromWalletOptions = ['working', 'roi', 'energy'];
//   const toWalletOptions = ['aurum'];

//   if (loading) {
//     return (
//       <div className="flex flex-col items-center justify-center min-h-[60vh]">
//         <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
//         <p className="text-muted-foreground">Loading wallet balances...</p>
//       </div>
//     );
//   }

//   const isSubmitDisabled = 
//     saving || 
//     !amount || 
//     Number(amount) < transferLimits.minTransferAmount || 
//     Number(amount) > balances[fromWallet] ||
//     transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers ||
//     (transferLimits.dailyTransferAmount + Number(amount || 0)) > transferLimits.maxDailyAmount ||
//     !userTransferStatus.isTransferAllowed;

//   return (
//     <div className="max-w-4xl mx-auto pt-16 md:pt-20 px-4 pb-12">
//       {/* Transfer Dialog */}
//       <TransferDialog
//         isOpen={dialog.isOpen}
//         onClose={closeDialog}
//         title={dialog.title}
//         message={dialog.message}
//         type={dialog.type}
//         onConfirm={dialog.onConfirm}
//       />

//       <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">Transfer Funds</h1>
//       <p className="text-primary mb-6">Move balance between your wallets</p>

//       {/* User Transfer Status Badge */}
//       {!userTransferStatus.isTransferAllowed && (
//         <div className="mb-6 p-5 rounded-2xl bg-gradient-to-r from-red-950/50 to-rose-950/50 border border-red-600/50 shadow-lg">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-4">
//               <Ban className="h-8 w-8 text-red-400" />
//               <div>
//                 <h3 className="text-lg font-semibold text-red-300">Transfer Functionality Disabled</h3>
//                 <p className="text-red-200/80 text-sm mt-1">
//                   Your account's transfer feature is currently blocked. Please contact support.
//                 </p>
//               </div>
//             </div>
//             <div className="px-4 py-2 bg-red-600/30 border border-red-500/50 rounded-lg">
//               <span className="text-red-200 font-medium">Status: Blocked</span>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Daily Transfer Limits */}
//       <div className={`mb-8 p-5 rounded-2xl border ${
//         userTransferStatus.isTransferAllowed 
//           ? 'bg-gradient-to-r from-indigo-950/40 to-purple-950/40 border-indigo-600/30' 
//           : 'bg-gradient-to-r from-gray-800/30 to-gray-900/30 border-gray-600/30 opacity-70'
//       }`}>
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-3">
//             <Shield className={`h-6 w-6 ${
//               userTransferStatus.isTransferAllowed ? 'text-indigo-400' : 'text-gray-400'
//             }`} />
//             <h3 className={`text-lg font-semibold ${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//             }`}>Daily Transfer Limits</h3>
//           </div>
//           <div className={`text-sm ${
//             userTransferStatus.isTransferAllowed ? 'text-indigo-300' : 'text-gray-400'
//           }`}>
//             Resets daily at midnight
//           </div>
//         </div>
        
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div className={`p-4 rounded-xl ${
//             userTransferStatus.isTransferAllowed ? 'bg-black/30' : 'bg-gray-900/30'
//           }`}>
//             <div className="flex items-center gap-2 mb-2">
//               <Clock className={`h-4 w-4 ${
//                 userTransferStatus.isTransferAllowed ? 'text-blue-400' : 'text-gray-400'
//               }`} />
//               <span className={`text-sm ${
//                 userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//               }`}>Transfers Today</span>
//             </div>
//             <div className={`text-2xl font-bold ${
//               userTransferStatus.isTransferAllowed ? 'text-blue-300' : 'text-gray-400'
//             }`}>
//               {transferLimits.dailyTransferCount} / {transferLimits.maxDailyTransfers}
//             </div>
//             <div className={`text-xs mt-1 ${
//               userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//             }`}>
//               {transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers 
//                 ? 'Limit reached' 
//                 : `${transferLimits.maxDailyTransfers - transferLimits.dailyTransferCount} remaining`}
//             </div>
//           </div>
          
//           <div className={`p-4 rounded-xl ${
//             userTransferStatus.isTransferAllowed ? 'bg-black/30' : 'bg-gray-900/30'
//           }`}>
//             <div className="flex items-center gap-2 mb-2">
//               <DollarSign className={`h-4 w-4 ${
//                 userTransferStatus.isTransferAllowed ? 'text-emerald-400' : 'text-gray-400'
//               }`} />
//               <span className={`text-sm ${
//                 userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//               }`}>Amount Today</span>
//             </div>
//             <div className={`text-2xl font-bold ${
//               userTransferStatus.isTransferAllowed ? 'text-emerald-300' : 'text-gray-400'
//             }`}>
//               ${transferLimits.dailyTransferAmount.toFixed(2)} / ${transferLimits.maxDailyAmount}
//             </div>
//             <div className={`text-xs mt-1 ${
//               userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//             }`}>
//               ${(transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount).toFixed(2)} remaining
//             </div>
//           </div>
          
//           <div className={`p-4 rounded-xl ${
//             userTransferStatus.isTransferAllowed ? 'bg-black/30' : 'bg-gray-900/30'
//           }`}>
//             <div className="flex items-center gap-2 mb-2">
//               <AlertTriangle className={`h-4 w-4 ${
//                 userTransferStatus.isTransferAllowed ? 'text-amber-400' : 'text-gray-400'
//               }`} />
//               <span className={`text-sm ${
//                 userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//               }`}>Minimum Transfer</span>
//             </div>
//             <div className={`text-2xl font-bold ${
//               userTransferStatus.isTransferAllowed ? 'text-amber-300' : 'text-gray-400'
//             }`}>
//               ${transferLimits.minTransferAmount}
//             </div>
//             <div className={`text-xs mt-1 ${
//               userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//             }`}>
//               per transfer
//             </div>
//           </div>
//         </div>
        
//         {transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers && userTransferStatus.isTransferAllowed && (
//           <div className="mt-4 p-3 bg-red-900/20 border border-red-700/40 rounded-lg flex items-center gap-3">
//             <AlertCircle className="h-5 w-5 text-red-400" />
//             <span className="text-red-300 text-sm">
//               Daily transfer limit reached. Please try again tomorrow.
//             </span>
//           </div>
//         )}
//       </div>

//       {/* User Info */}
//       <div className={`mb-6 p-4 glass rounded-xl ${
//         userTransferStatus.isTransferAllowed ? 'border-border' : 'border-gray-600/50'
//       }`}>
//         <div className="flex items-center gap-4">
//           <div className="icon-electric">
//             <Wallet className={`h-6 w-6 ${
//               userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//             }`} />
//           </div>
//           <div>
//             <p className="text-muted-foreground text-sm">Transferring as</p>
//             <p className={`font-medium ${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//             }`}>{userName} (ID: {userId})</p>
//             <div className="flex items-center gap-2 mt-1">
//               <span className="text-xs text-muted-foreground">
//                 Registration: {userRegistrationDate}
//               </span>
//               <span className={`text-xs px-2 py-0.5 rounded-full ${
//                 userTransferStatus.internalTransferStatus === 'blocked'
//                   ? 'bg-red-900/40 text-red-200 border border-red-700/50'
//                   : 'bg-emerald-900/40 text-emerald-200 border border-emerald-700/50'
//               }`}>
//                 Transfer: {userTransferStatus.internalTransferStatus === 'blocked' ? 'Blocked' : 'Allowed'}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Balances */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-10">
//         {Object.entries(balances).map(([key, val]) => (
//           <div
//             key={key}
//             className={`p-4 rounded-2xl ${getWalletColor(key)} ${
//               !userTransferStatus.isTransferAllowed ? 'opacity-70' : ''
//             }`}
//           >
//             <div className="flex items-center justify-between mb-2">
//               <p className={`text-sm font-medium ${
//                 userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//               }`}>{getWalletLabel(key)}</p>
//               <span className="text-lg">{getWalletIcon(key)}</span>
//             </div>
//             <p className={`text-2xl font-bold ${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//             }`}>${val.toFixed(2)}</p>
//             {key === 'energy' && (
//               <p className={`text-xs mt-1 ${
//                 userTransferStatus.isTransferAllowed ? 'text-yellow-400' : 'text-gray-400'
//               }`}>From direct referrals</p>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Transfer Card */}
//       <div className={`rounded-2xl p-6 md:p-8 shadow-2xl ${
//         userTransferStatus.isTransferAllowed 
//           ? 'card-glow bg-card' 
//           : 'bg-gray-900/50 border border-gray-600/30'
//       }`}>
//         <div className="grid md:grid-cols-3 gap-6 md:gap-8">
//           {/* From */}
//           <div>
//             <label className={`block font-medium mb-3 ${
//               userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//             }`}>From Wallet</label>
//             <div className="space-y-3">
//               {fromWalletOptions.map((w) => (
//                 <button
//                   key={w}
//                   type="button"
//                   onClick={() => {
//                     if (userTransferStatus.isTransferAllowed) {
//                       setFromWallet(w);
//                     }
//                   }}
//                   disabled={!userTransferStatus.isTransferAllowed}
//                   className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
//                     !userTransferStatus.isTransferAllowed
//                       ? 'border-gray-600/30 bg-gray-800/30 cursor-not-allowed'
//                       : fromWallet === w
//                       ? 'border-primary bg-primary/10'
//                       : 'border-border hover:border-primary/60 bg-card'
//                   }`}
//                 >
//                   <div className={`font-medium flex items-center justify-between ${
//                     userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                   }`}>
//                     <span>{getWalletLabel(w)}</span>
//                     <span>{getWalletIcon(w)}</span>
//                   </div>
//                   <div className={`text-sm mt-1 ${
//                     userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//                   }`}>${balances[w].toFixed(2)}</div>
//                   {w === 'energy' && (
//                     <div className={`text-xs mt-1 ${
//                       userTransferStatus.isTransferAllowed ? 'text-yellow-400' : 'text-gray-400'
//                     }`}>Direct referral bonus</div>
//                   )}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Amount */}
//           <div>
//             <label className={`block font-medium mb-3 ${
//               userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//             }`}>
//               Amount (Min: ${transferLimits.minTransferAmount})
//             </label>
//             <div className="relative">
//               <input
//                 type="number"
//                 step="0.01"
//                 min={transferLimits.minTransferAmount}
//                 max={Math.min(balances[fromWallet], transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount)}
//                 value={amount}
//                 onChange={(e) => {
//                   if (userTransferStatus.isTransferAllowed) {
//                     setAmount(e.target.value);
//                   }
//                 }}
//                 disabled={!userTransferStatus.isTransferAllowed}
//                 placeholder="0.00"
//                 className={`w-full border rounded-xl px-5 py-6 text-3xl font-bold text-center focus:outline-none focus:ring-1 ${
//                   userTransferStatus.isTransferAllowed
//                     ? 'bg-background border-border text-foreground focus:border-primary focus:ring-ring'
//                     : 'bg-gray-800/30 border-gray-600/30 text-gray-400 cursor-not-allowed'
//                 }`}
//               />
//               <div className={`absolute right-4 top-1/2 -translate-y-1/2 font-medium ${
//                 userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//               }`}>
//                 USD
//               </div>
//             </div>

//             {userTransferStatus.isTransferAllowed ? (
//               <div className="flex flex-wrap gap-2 mt-4">
//                 {[10, 25, 50, 100].map((v) => (
//                   <button
//                     key={v}
//                     type="button"
//                     onClick={() => setAmount(v.toString())}
//                     className="px-4 py-2 bg-primary/10 hover:bg-primary/20 border border-primary/30 rounded-lg text-sm text-primary transition"
//                   >
//                     ${v}
//                   </button>
//                 ))}
//                 <button
//                   type="button"
//                   onClick={() => {
//                     const maxAllowed = Math.min(
//                       balances[fromWallet],
//                       transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount
//                     );
//                     setAmount(maxAllowed.toFixed(2));
//                   }}
//                   className="px-4 py-2 bg-emerald-900/30 hover:bg-emerald-800/40 border border-emerald-700/40 rounded-lg text-sm text-emerald-300 transition"
//                 >
//                   MAX
//                 </button>
//               </div>
//             ) : (
//               <div className="mt-4 text-sm text-gray-400">
//                 Amount selection disabled
//               </div>
//             )}
            
//             {/* Validation messages */}
//             {userTransferStatus.isTransferAllowed && amount && Number(amount) < transferLimits.minTransferAmount && (
//               <div className="mt-2 text-sm text-red-400 flex items-center gap-2">
//                 <AlertCircle className="h-4 w-4" />
//                 Minimum amount is ${transferLimits.minTransferAmount}
//               </div>
//             )}
//             {userTransferStatus.isTransferAllowed && amount && (Number(amount) + transferLimits.dailyTransferAmount) > transferLimits.maxDailyAmount && (
//               <div className="mt-2 text-sm text-red-400 flex items-center gap-2">
//                 <AlertCircle className="h-4 w-4" />
//                 Would exceed daily limit of ${transferLimits.maxDailyAmount}
//               </div>
//             )}
//           </div>

//           {/* To */}
//           <div>
//             <label className={`block font-medium mb-3 ${
//               userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//             }`}>To Wallet</label>
//             <div className="space-y-3">
//               {toWalletOptions.map((w) => (
//                 <button
//                   key={w}
//                   type="button"
//                   onClick={() => {
//                     if (userTransferStatus.isTransferAllowed) {
//                       setToWallet(w);
//                     }
//                   }}
//                   disabled={!userTransferStatus.isTransferAllowed}
//                   className={`w-full p-4 rounded-xl border-2 transition-all text-left ${
//                     !userTransferStatus.isTransferAllowed
//                       ? 'border-gray-600/30 bg-gray-800/30 cursor-not-allowed'
//                       : toWallet === w
//                       ? 'border-primary bg-primary/10'
//                       : 'border-border hover:border-primary/60 bg-card'
//                   }`}
//                 >
//                   <div className={`font-medium flex items-center justify-between ${
//                     userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                   }`}>
//                     <span>{getWalletLabel(w)}</span>
//                     <span>{getWalletIcon(w)}</span>
//                   </div>
//                   <div className={`text-sm mt-1 ${
//                     userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//                   }`}>${balances[w].toFixed(2)}</div>
//                   <div className={`text-xs mt-1 ${
//                     userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//                   }`}>For package purchases</div>
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Summary & Button */}
//         <div className={`mt-10 pt-8 ${
//           userTransferStatus.isTransferAllowed ? 'border-t border-border' : 'border-t border-gray-600/30'
//         }`}>
//           <div className={`rounded-xl p-6 mb-6 ${
//             userTransferStatus.isTransferAllowed ? 'bg-background/60' : 'bg-gray-800/30'
//           }`}>
//             <div className="grid md:grid-cols-2 gap-6 text-sm">
//               <div>
//                 <div className={`mb-1 ${
//                   userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//                 }`}>Transferring from</div>
//                 <div className={`font-medium flex items-center gap-2 ${
//                   userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                 }`}>
//                   <span>{getWalletIcon(fromWallet)}</span>
//                   <span>{getWalletLabel(fromWallet)}</span>
//                 </div>
//               </div>
//               <div>
//                 <div className={`mb-1 ${
//                   userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//                 }`}>To</div>
//                 <div className={`font-medium flex items-center gap-2 ${
//                   userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                 }`}>
//                   <span>{getWalletIcon(toWallet)}</span>
//                   <span>{getWalletLabel(toWallet)}</span>
//                 </div>
//               </div>
//               <div>
//                 <div className={`mb-1 ${
//                   userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//                 }`}>Amount</div>
//                 <div className={`text-2xl font-bold ${
//                   userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                 }`}>
//                   {amount ? `$${Number(amount).toFixed(2)}` : '—'}
//                 </div>
//               </div>
//               <div>
//                 <div className={`mb-1 ${
//                   userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//                 }`}>New {getWalletLabel(toWallet)} balance</div>
//                 <div className={`text-xl font-bold ${
//                   userTransferStatus.isTransferAllowed ? 'text-emerald-400' : 'text-gray-400'
//                 }`}>
//                   ${(balances[toWallet] + Number(amount || 0)).toFixed(2)}
//                 </div>
//               </div>
//             </div>
            
//             {/* Daily limits summary */}
//             {userTransferStatus.isTransferAllowed && amount && Number(amount) >= transferLimits.minTransferAmount && (
//               <div className={`mt-6 pt-6 ${
//                 userTransferStatus.isTransferAllowed ? 'border-t border-border/30' : 'border-t border-gray-600/30'
//               }`}>
//                 <div className={`text-sm mb-2 ${
//                   userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//                 }`}>Daily Limits Summary</div>
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <div className={`text-xs ${
//                       userTransferStatus.isTransferAllowed ? 'text-blue-300' : 'text-gray-400'
//                     }`}>Transfers Today</div>
//                     <div className={`font-medium ${
//                       userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                     }`}>
//                       {transferLimits.dailyTransferCount} → {transferLimits.dailyTransferCount + 1} / {transferLimits.maxDailyTransfers}
//                     </div>
//                   </div>
//                   <div>
//                     <div className={`text-xs ${
//                       userTransferStatus.isTransferAllowed ? 'text-emerald-300' : 'text-gray-400'
//                     }`}>Amount Today</div>
//                     <div className={`font-medium ${
//                       userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//                     }`}>
//                       ${transferLimits.dailyTransferAmount.toFixed(2)} → ${(transferLimits.dailyTransferAmount + Number(amount)).toFixed(2)} / ${transferLimits.maxDailyAmount}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           <div className="flex flex-col md:flex-row gap-4 justify-center">
//             {userTransferStatus.isTransferAllowed ? (
//               <>
//                 <button
//                   onClick={handleTransfer}
//                   disabled={isSubmitDisabled}
//                   className="btn-electric disabled:opacity-50 disabled:cursor-not-allowed py-4 px-12 rounded-xl text-lg transition shadow-lg flex items-center justify-center gap-3 min-w-[240px]"
//                 >
//                   {saving ? (
//                     <>
//                       <Loader2 className="h-5 w-5 animate-spin" />
//                       Processing...
//                     </>
//                   ) : (
//                     <>
//                       <ArrowRightLeft className="h-5 w-5" />
//                       Confirm Transfer
//                     </>
//                   )}
//                 </button>

//                 <button
//                   onClick={() => {
//                     setAmount('');
//                     setFromWallet('working');
//                     setToWallet('aurum');
//                   }}
//                   className="border border-border hover:bg-primary/5 text-foreground px-10 py-4 rounded-xl transition"
//                 >
//                   Cancel
//                 </button>
//               </>
//             ) : (
//               <div className="w-full text-center py-6">
//                 <Ban className="h-12 w-12 text-red-400 mx-auto mb-4" />
//                 <p className="text-red-300 font-medium text-lg mb-2">Transfer Functionality Disabled</p>
//                 <p className="text-gray-400 text-sm">Your account's transfer feature is currently blocked. Please contact support.</p>
//               </div>
//             )}
//           </div>
//         </div>

//         {error && (
//           <div className="mt-6 p-4 bg-destructive/10 border border-destructive/30 rounded-xl text-destructive-foreground text-center">
//             {error}
//           </div>
//         )}
//       </div>

//       {/* Rules with limits */}
//       <div className={`mt-12 glass rounded-2xl p-6 ${
//         userTransferStatus.isTransferAllowed ? 'border-border' : 'border-gray-600/30'
//       }`}>
//         <div className="flex items-center gap-3 mb-4">
//           <AlertCircle className={`${
//             userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
//           }`} />
//           <h3 className={`text-lg font-semibold ${
//             userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
//           }`}>Transfer Rules & Limits</h3>
//         </div>
//         <ul className={`space-y-2 text-sm ${
//           userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
//         }`}>
//           <li className="flex items-center gap-2">
//             <div className={`h-1.5 w-1.5 rounded-full ${
//               userTransferStatus.isTransferAllowed ? 'bg-primary' : 'bg-gray-400'
//             }`}></div>
//             <span>Transfer from: <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-300'
//             }`}>AV Power</strong>, <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-300'
//             }`}>AV ROI</strong>, or <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-300'
//             }`}>AV Energy</strong> wallet</span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className={`h-1.5 w-1.5 rounded-full ${
//               userTransferStatus.isTransferAllowed ? 'bg-primary' : 'bg-gray-400'
//             }`}></div>
//             <span>Destination wallet: <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-300'
//             }`}>Aerovolt Wallet</strong> only</span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className={`h-1.5 w-1.5 rounded-full ${
//               userTransferStatus.isTransferAllowed ? 'bg-primary' : 'bg-gray-400'
//             }`}></div>
//             <span>Maximum <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-blue-300' : 'text-gray-300'
//             }`}>1 transfer</strong> allowed per day</span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className={`h-1.5 w-1.5 rounded-full ${
//               userTransferStatus.isTransferAllowed ? 'bg-primary' : 'bg-gray-400'
//             }`}></div>
//             <span>Daily transfer limit: <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-emerald-300' : 'text-gray-300'
//             }`}>${transferLimits.maxDailyAmount}</strong></span>
//           </li>
//           <li className="flex items-center gap-2">
//             <div className={`h-1.5 w-1.5 rounded-full ${
//               userTransferStatus.isTransferAllowed ? 'bg-primary' : 'bg-gray-400'
//             }`}></div>
//             <span>Minimum transfer: <strong className={`${
//               userTransferStatus.isTransferAllowed ? 'text-amber-300' : 'text-gray-300'
//             }`}>${transferLimits.minTransferAmount}</strong></span>
//           </li>
//           {!userTransferStatus.isTransferAllowed && (
//             <li className="flex items-center gap-2">
//               <div className="h-1.5 w-1.5 rounded-full bg-red-400"></div>
//               <span><strong className="text-red-300">TRANSFER BLOCKED:</strong> Your account's transfer feature is currently disabled</span>
//             </li>
//           )}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Transfer;



import React, { useState, useEffect } from 'react';
import { database, ref, get, update, set } from '../../firebase';
import { Wallet, ArrowRightLeft, AlertCircle, CheckCircle2, Loader2, Clock, Shield, DollarSign, AlertTriangle, X, Ban } from 'lucide-react';

// Dialog Component for Transfer
const TransferDialog = ({ isOpen, onClose, title, message, type = 'info', onConfirm }) => {
  if (!isOpen) return null;

  const getDialogStyles = () => {
    const bgColor = '#132131';
    
    switch (type) {
      case 'success':
        return {
          bg: 'bg-[#132131]',
          border: 'border-green-500/30',
          icon: <CheckCircle2 className="text-green-400" size={40} />,
          titleColor: 'text-white',
          textColor: 'text-gray-200'
        };
      case 'error':
        return {
          bg: 'bg-[#132131]',
          border: 'border-red-500/30',
          icon: <AlertCircle className="text-red-400" size={40} />,
          titleColor: 'text-white',
          textColor: 'text-gray-200'
        };
      case 'warning':
        return {
          bg: 'bg-[#132131]',
          border: 'border-yellow-500/30',
          icon: <AlertTriangle className="text-yellow-400" size={40} />,
          titleColor: 'text-white',
          textColor: 'text-gray-200'
        };
      case 'blocked':
        return {
          bg: 'bg-[#132131]',
          border: 'border-red-500/30',
          icon: <Ban className="text-red-500" size={40} />,
          titleColor: 'text-white',
          textColor: 'text-gray-200'
        };
      default:
        return {
          bg: 'bg-[#132131]',
          border: 'border-primary/30',
          icon: <AlertCircle className="text-blue-400" size={40} />,
          titleColor: 'text-white',
          textColor: 'text-gray-200'
        };
    }
  };

  const styles = getDialogStyles();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />
      
      <div className={`relative z-10 w-full max-w-sm rounded-xl ${styles.bg} border ${styles.border} p-6 shadow-2xl`}>
        <button
          onClick={onClose}
          className="absolute right-3 top-3 text-gray-400 hover:text-white transition-colors"
        >
          <X size={20} />
        </button>

        <div className="text-center">
          <div className="flex justify-center mb-4">
            {styles.icon}
          </div>
          
          <h3 className={`text-xl font-bold mb-3 font-heading ${styles.titleColor}`}>
            {title}
          </h3>
          
          <div className={`text-sm mb-6 font-body ${styles.textColor} whitespace-pre-line`}>
            {message}
          </div>
          
          <div className="flex gap-3 justify-center">
            {onConfirm && type === 'info' && (
              <button
                onClick={onConfirm}
                className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition"
              >
                Confirm
              </button>
            )}
            <button
              onClick={onClose}
              className={`px-6 py-2 rounded-lg font-medium transition ${
                type === 'success' 
                  ? 'bg-green-500 hover:bg-green-600 text-white'
                  : type === 'error'
                  ? 'bg-red-500 hover:bg-red-600 text-white'
                  : type === 'blocked'
                  ? 'bg-red-600 hover:bg-red-700 text-white'
                  : 'bg-gray-700 hover:bg-gray-600 text-white'
              }`}
            >
              {onConfirm ? 'Cancel' : 'OK'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Transfer = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [balances, setBalances] = useState({
    working: 0,
    roi: 0,
    aurum: 0,
    energy: 0
  });

  const [fromWallet, setFromWallet] = useState('working');
  const [toWallet, setToWallet] = useState('aurum');
  const [amount, setAmount] = useState('');

  // Transfer limits state
  const [transferLimits, setTransferLimits] = useState({
    dailyTransferCount: 0,
    lastTransferDate: null,
    dailyTransferAmount: 0,
    maxDailyTransfers: 1,
    maxDailyAmount: 1000,
    minTransferAmount: 10
  });

  // User transfer status
  const [userTransferStatus, setUserTransferStatus] = useState({
    internalTransferStatus: 'open', // 'open' or 'blocked'
    isTransferAllowed: true
  });

  // Dialog state
  const [dialog, setDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: null
  });

  // Get user info from localStorage
  const userId = localStorage.getItem('userId') || '';
  const userName = localStorage.getItem('userName') || '';
  const userEmail = localStorage.getItem('userEmail') || '';
  const userDbKey = localStorage.getItem('dbKey') || '';
  const userRegistrationDate = localStorage.getItem('registrationDate') || '';

  // Format date to YYYY-MM-DD
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getTodayDate = () => {
    return formatDate(new Date());
  };

  const resetDailyLimitsIfNewDay = () => {
    const today = getTodayDate();
    if (transferLimits.lastTransferDate !== today) {
      setTransferLimits(prev => ({
        ...prev,
        dailyTransferCount: 0,
        dailyTransferAmount: 0,
        lastTransferDate: today
      }));
    }
  };

  // Show dialog function
  const showDialog = (title, message, type = 'info', onConfirm = null) => {
    setDialog({
      isOpen: true,
      title,
      message,
      type,
      onConfirm
    });
  };

  // Close dialog function
  const closeDialog = () => {
    setDialog({
      isOpen: false,
      title: '',
      message: '',
      type: 'info',
      onConfirm: null
    });
  };

  // Check user transfer status
  const checkUserTransferStatus = (userData) => {
    const internalTransferStatus = userData.internalTransferStatus || 'open';
    const isTransferAllowed = internalTransferStatus !== 'blocked';
    
    setUserTransferStatus({
      internalTransferStatus,
      isTransferAllowed
    });

    // If transfer is blocked, show blocked dialog immediately
    if (internalTransferStatus === 'blocked') {
      showDialog(
        'Transfer Blocked',
        'Your account transfer functionality has been temporarily disabled. Please contact support for assistance.',
        'blocked'
      );
    }

    return isTransferAllowed;
  };

  useEffect(() => {
    if (!userId) {
      showDialog('Error', 'User ID not found. Please login again.', 'error');
      setLoading(false);
      return;
    }

    loadUserData();
  }, [userId]);

  const loadUserData = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!userDbKey || !userRegistrationDate) {
        showDialog('Error', 'User session data incomplete. Please login again.', 'error');
        setLoading(false);
        return;
      }

      // Get user data from date-wise structure: users/2026-02-06/dbKey
      const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
      const userSnapshot = await get(userRef);
      
      if (!userSnapshot.exists()) {
        // Try to find user in any date folder
        const usersRef = ref(database, 'users');
        const allUsersSnapshot = await get(usersRef);
        
        if (!allUsersSnapshot.exists()) {
          showDialog('Error', 'No users found in database.', 'error');
          setLoading(false);
          return;
        }

        const allUsers = allUsersSnapshot.val();
        let userFound = null;
        let foundDate = null;

        // Search through all date folders
        for (const date in allUsers) {
          if (typeof allUsers[date] === 'object') {
            for (const [key, user] of Object.entries(allUsers[date])) {
              if (user.sponsorId === userId || user.dbKey === userDbKey) {
                userFound = user;
                foundDate = date;
                break;
              }
            }
            if (userFound) break;
          }
        }

        if (!userFound) {
          showDialog('Error', 'User record not found. Please check your login.', 'error');
          setLoading(false);
          return;
        }

        // Update localStorage with found date
        localStorage.setItem('registrationDate', foundDate);
        await loadUserWallets(userFound);
        checkUserTransferStatus(userFound);
      } else {
        const userData = userSnapshot.val();
        await loadUserWallets(userData);
        checkUserTransferStatus(userData);
      }

    } catch (err) {
      console.error("Load user data error:", err);
      showDialog('Error', 'Failed to load user data. Please try again.', 'error');
      setLoading(false);
    }
  };

  const loadUserWallets = async (userData) => {
    try {
      const wallets = userData.wallets || {};
      
      const working = Number(wallets.working || 0);
      const roi = Number(wallets.roi || 0);
      const aurum = Number(wallets.aurum || 0);
      const energy = Number(wallets.energy || 0);

      setBalances({ working, roi, aurum, energy });

      const updates = {};
      if (wallets.working === undefined) updates['wallets/working'] = working;
      if (wallets.roi === undefined) updates['wallets/roi'] = roi;
      if (wallets.aurum === undefined) updates['wallets/aurum'] = aurum;
      if (wallets.energy === undefined) updates['wallets/energy'] = energy;

      if (Object.keys(updates).length > 0) {
        const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
        updates['updatedAt'] = new Date().toISOString();
        await update(userRef, updates);
      }

    } catch (err) {
      console.error("Load wallets error:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const fetchTransferHistory = async () => {
    try {
      const today = getTodayDate();
      
      const transfersRef = ref(database, 'Transfers');
      const transfersSnapshot = await get(transfersRef);
      
      let dailyCount = 0;
      let dailyAmount = 0;
      let lastDate = null;

      if (transfersSnapshot.exists()) {
        const allTransfers = transfersSnapshot.val();
        
        Object.values(allTransfers).forEach(transfer => {
          if (transfer && transfer.userId === userId) {
            const transferDate = formatDate(new Date(transfer.timestamp));
            
            if (transferDate === today) {
              dailyCount++;
              dailyAmount += parseFloat(transfer.amount) || 0;
            }
            
            if (!lastDate || transfer.timestamp > lastDate) {
              lastDate = transferDate;
            }
          }
        });
      }

      setTransferLimits(prev => ({
        ...prev,
        dailyTransferCount: dailyCount,
        dailyTransferAmount: dailyAmount,
        lastTransferDate: lastDate || today
      }));

    } catch (error) {
      console.error('Error fetching transfer history:', error);
    }
  };

  const generateTransferId = () => {
    const timestamp = Date.now().toString(36).toUpperCase();
    const random = Math.random().toString(36).substr(2, 5).toUpperCase();
    return `T${timestamp}${random}`;
  };

  const saveTransferToFirebase = async (transferData) => {
    try {
      const today = getTodayDate();
      const transferId = generateTransferId();
      
      // Create transfer record
      const transferRecord = {
        id: transferId,
        userId: userId,
        userName: userName,
        fromWallet: transferData.fromWallet,
        toWallet: transferData.toWallet,
        amount: transferData.amount,
        date: new Date().toISOString(),
        status: 'completed',
        timestamp: Date.now(),
        userEmail: userEmail,
        previousFromBalance: balances[transferData.fromWallet],
        previousToBalance: balances[transferData.toWallet],
        newFromBalance: balances[transferData.fromWallet] - transferData.amount,
        newToBalance: balances[transferData.toWallet] + transferData.amount,
        transferDate: today,
        dailyTransferCount: transferLimits.dailyTransferCount + 1,
        dailyTransferAmount: transferLimits.dailyTransferAmount + transferData.amount,
        userDbKey: userDbKey,
        userRegistrationDate: userRegistrationDate
      };

      // Save transfer with date-wise structure: Transfers/2026-02-06/userId/transferId
      const transfersRef = ref(database, `Transfers/${today}/${userId}/${transferId}`);
      await set(transfersRef, transferRecord);
      
      console.log('Transfer saved to Firebase with date-wise structure:', today, transferId);
      
      return transferRecord;
    } catch (error) {
      console.error("Error saving transfer to Firebase:", error);
      throw error;
    }
  };

  const handleTransferValidation = () => {
    // First check if user is allowed to transfer
    if (!userTransferStatus.isTransferAllowed) {
      showDialog(
        'Transfer Blocked',
        'Your account transfer functionality has been temporarily disabled. Please contact support for assistance.',
        'blocked'
      );
      return false;
    }

    const today = getTodayDate();
    const value = Number(amount);
    
    // Reset limits if new day
    if (transferLimits.lastTransferDate !== today) {
      resetDailyLimitsIfNewDay();
    }

    // Validation
    if (!value || value <= 0) {
      showDialog('Validation Error', 'Please enter a valid amount greater than 0.', 'error');
      return false;
    }
    
    if (value < transferLimits.minTransferAmount) {
      showDialog('Validation Error', `Minimum transfer amount is $${transferLimits.minTransferAmount}.`, 'error');
      return false;
    }
    
    if (value > balances[fromWallet]) {
      showDialog('Insufficient Balance', `Insufficient balance in ${getWalletLabel(fromWallet)}.`, 'error');
      return false;
    }
    
    // Check daily transfer count (only 1 transfer per day)
    if (transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers) {
      showDialog('Daily Limit Reached', `Daily transfer limit reached. You can only make ${transferLimits.maxDailyTransfers} transfer per day. Please try again tomorrow.`, 'error');
      return false;
    }
    
    // Check daily amount limit
    const projectedDailyAmount = transferLimits.dailyTransferAmount + value;
    if (projectedDailyAmount > transferLimits.maxDailyAmount) {
      showDialog('Daily Limit Exceeded', `Daily transfer limit is $${transferLimits.maxDailyAmount}. You've already transferred $${transferLimits.dailyTransferAmount.toFixed(2)} today.`, 'error');
      return false;
    }
    
    if (fromWallet === toWallet) {
      showDialog('Invalid Transfer', 'Cannot transfer to the same wallet.', 'error');
      return false;
    }

    return true;
  };

  const confirmTransfer = async () => {
    const today = getTodayDate();
    const value = Number(amount);
    
    setSaving(true);
    setError(null);

    try {
      if (!userDbKey || !userRegistrationDate) {
        throw new Error("User session expired. Please login again.");
      }

      const newFromBalance = balances[fromWallet] - value;
      const newToBalance = balances[toWallet] + value;

      // Update user wallet balances
      const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
      const updates = {
        [`wallets/${fromWallet}`]: newFromBalance,
        [`wallets/${toWallet}`]: newToBalance,
        'updatedAt': new Date().toISOString()
      };

      await saveTransferToFirebase({
        fromWallet,
        toWallet,
        amount: value
      });

      await update(userRef, updates);

      const newDailyCount = transferLimits.dailyTransferCount + 1;
      const newDailyAmount = transferLimits.dailyTransferAmount + value;
      
      setTransferLimits(prev => ({
        ...prev,
        dailyTransferCount: newDailyCount,
        dailyTransferAmount: newDailyAmount,
        lastTransferDate: today
      }));

      setBalances({
        ...balances,
        [fromWallet]: newFromBalance,
        [toWallet]: newToBalance
      });

      // Show success dialog
      showDialog(
        'Transfer Successful',
        `✅ Transfer Completed!\n\n$${value.toFixed(2)} transferred from ${getWalletLabel(fromWallet)} to ${getWalletLabel(toWallet)}\n\nDaily transfers: ${newDailyCount}/${transferLimits.maxDailyTransfers}\nDaily amount: $${newDailyAmount.toFixed(2)}/$${transferLimits.maxDailyAmount}`,
        'success'
      );
      
      setAmount('');
      
    } catch (err) {
      console.error("Transfer error:", err);
      showDialog('Transfer Failed', 'Transfer failed. Please try again.', 'error');
      
      await loadUserData();
      await fetchTransferHistory();
    } finally {
      setSaving(false);
    }
  };

  const handleTransfer = async () => {
    if (!handleTransferValidation()) {
      return;
    }

    const value = Number(amount);
    
    // Show confirmation dialog
    showDialog(
      'Confirm Transfer',
      `Transfer Details:\n\nFrom: ${getWalletLabel(fromWallet)}\nTo: ${getWalletLabel(toWallet)}\nAmount: $${value.toFixed(2)}\n\nDaily transfers used: ${transferLimits.dailyTransferCount}/${transferLimits.maxDailyTransfers}\nDaily amount: $${(transferLimits.dailyTransferAmount + value).toFixed(2)}/$${transferLimits.maxDailyAmount}\n\nProceed with transfer?`,
      'info',
      confirmTransfer
    );
  };

  const getWalletLabel = (key) => {
    const map = {
      working: "AV Power Wallet",
      roi: "AV ROI Wallet",
      aurum: "Aerovolt Wallet",
      energy: "AV Energy Wallet"
    };
    return map[key] || key.charAt(0).toUpperCase() + key.slice(1);
  };

  const getWalletIcon = (key) => {
    switch(key) {
      case 'working': return '💰';
      case 'roi': return '📈';
      case 'aurum': return '🪙';
      case 'energy': return '⚡';
      default: return '💳';
    }
  };

  const getWalletColor = (key) => {
    switch(key) {
      case 'working': return 'from-blue-950/30 to-card border-blue-600/30';
      case 'roi': return 'from-emerald-950/30 to-card border-emerald-600/30';
      case 'aurum': return 'from-amber-950/30 to-card border-amber-600/30';
      case 'energy': return 'from-yellow-950/30 to-card border-yellow-600/30';
      default: return 'from-card to-card border-border';
    }
  };

  const fromWalletOptions = ['working', 'roi', 'energy'];
  const toWalletOptions = ['aurum'];

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh]">
        <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
        <p className="text-muted-foreground">Loading wallet balances...</p>
      </div>
    );
  }

  const isSubmitDisabled = 
    saving || 
    !amount || 
    Number(amount) < transferLimits.minTransferAmount || 
    Number(amount) > balances[fromWallet] ||
    transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers ||
    (transferLimits.dailyTransferAmount + Number(amount || 0)) > transferLimits.maxDailyAmount ||
    !userTransferStatus.isTransferAllowed;

  return (
    <div className="max-w-4xl mx-auto pt-16 px-4 pb-12">
      {/* Transfer Dialog */}
      <TransferDialog
        isOpen={dialog.isOpen}
        onClose={closeDialog}
        title={dialog.title}
        message={dialog.message}
        type={dialog.type}
        onConfirm={dialog.onConfirm}
      />

      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground">Transfer Funds</h1>
        <p className="text-sm md:text-base text-primary mt-1">Move balance between your wallets</p>
      </div>

      {/* User Transfer Status Badge */}
      {!userTransferStatus.isTransferAllowed && (
        <div className="mb-6 p-4 rounded-xl bg-gradient-to-r from-red-950/50 to-rose-950/50 border border-red-600/50">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-start gap-3">
              <Ban className="h-6 w-6 text-red-400 shrink-0 mt-0.5" />
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-red-300">Transfer Functionality Disabled</h3>
                <p className="text-xs sm:text-sm text-red-200/80 mt-1">
                  Your account's transfer feature is currently blocked. Please contact support.
                </p>
              </div>
            </div>
            <div className="px-3 py-1.5 bg-red-600/30 border border-red-500/50 rounded-lg self-start sm:self-center">
              <span className="text-xs sm:text-sm text-red-200 font-medium">Status: Blocked</span>
            </div>
          </div>
        </div>
      )}

      {/* Daily Transfer Limits */}
      <div className={`mb-8 p-4 sm:p-5 rounded-xl border ${
        userTransferStatus.isTransferAllowed 
          ? 'bg-gradient-to-r from-indigo-950/40 to-purple-950/40 border-indigo-600/30' 
          : 'bg-gradient-to-r from-gray-800/30 to-gray-900/30 border-gray-600/30 opacity-70'
      }`}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-4">
          <div className="flex items-center gap-2">
            <Shield className={`h-5 w-5 sm:h-6 sm:w-6 ${
              userTransferStatus.isTransferAllowed ? 'text-indigo-400' : 'text-gray-400'
            }`} />
            <h3 className={`text-base sm:text-lg font-semibold ${
              userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
            }`}>Daily Transfer Limits</h3>
          </div>
          <div className={`text-xs sm:text-sm ${
            userTransferStatus.isTransferAllowed ? 'text-indigo-300' : 'text-gray-400'
          }`}>
            Resets daily at midnight
          </div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          <div className={`p-3 rounded-lg ${
            userTransferStatus.isTransferAllowed ? 'bg-black/30' : 'bg-gray-900/30'
          }`}>
            <div className="flex items-center gap-1.5 mb-1.5">
              <Clock className={`h-3.5 w-3.5 ${
                userTransferStatus.isTransferAllowed ? 'text-blue-400' : 'text-gray-400'
              }`} />
              <span className={`text-xs ${
                userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
              }`}>Transfers Today</span>
            </div>
            <div className={`text-xl sm:text-2xl font-bold ${
              userTransferStatus.isTransferAllowed ? 'text-blue-300' : 'text-gray-400'
            }`}>
              {transferLimits.dailyTransferCount} / {transferLimits.maxDailyTransfers}
            </div>
            <div className={`text-xs mt-1 ${
              userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
            }`}>
              {transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers 
                ? 'Limit reached' 
                : `${transferLimits.maxDailyTransfers - transferLimits.dailyTransferCount} remaining`}
            </div>
          </div>
          
          <div className={`p-3 rounded-lg ${
            userTransferStatus.isTransferAllowed ? 'bg-black/30' : 'bg-gray-900/30'
          }`}>
            <div className="flex items-center gap-1.5 mb-1.5">
              <DollarSign className={`h-3.5 w-3.5 ${
                userTransferStatus.isTransferAllowed ? 'text-emerald-400' : 'text-gray-400'
              }`} />
              <span className={`text-xs ${
                userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
              }`}>Amount Today</span>
            </div>
            <div className={`text-xl sm:text-2xl font-bold ${
              userTransferStatus.isTransferAllowed ? 'text-emerald-300' : 'text-gray-400'
            }`}>
              ${transferLimits.dailyTransferAmount.toFixed(2)} / ${transferLimits.maxDailyAmount}
            </div>
            <div className={`text-xs mt-1 ${
              userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
            }`}>
              ${(transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount).toFixed(2)} remaining
            </div>
          </div>
          
          <div className={`p-3 rounded-lg ${
            userTransferStatus.isTransferAllowed ? 'bg-black/30' : 'bg-gray-900/30'
          }`}>
            <div className="flex items-center gap-1.5 mb-1.5">
              <AlertTriangle className={`h-3.5 w-3.5 ${
                userTransferStatus.isTransferAllowed ? 'text-amber-400' : 'text-gray-400'
              }`} />
              <span className={`text-xs ${
                userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
              }`}>Minimum Transfer</span>
            </div>
            <div className={`text-xl sm:text-2xl font-bold ${
              userTransferStatus.isTransferAllowed ? 'text-amber-300' : 'text-gray-400'
            }`}>
              ${transferLimits.minTransferAmount}
            </div>
            <div className={`text-xs mt-1 ${
              userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
            }`}>
              per transfer
            </div>
          </div>
        </div>
        
        {transferLimits.dailyTransferCount >= transferLimits.maxDailyTransfers && userTransferStatus.isTransferAllowed && (
          <div className="mt-4 p-2.5 bg-red-900/20 border border-red-700/40 rounded-lg flex items-center gap-2">
            <AlertCircle className="h-4 w-4 text-red-400 shrink-0" />
            <span className="text-xs sm:text-sm text-red-300">
              Daily transfer limit reached. Please try again tomorrow.
            </span>
          </div>
        )}
      </div>

      {/* User Info */}
      <div className={`mb-6 p-3.5 glass rounded-lg ${
        userTransferStatus.isTransferAllowed ? 'border-border' : 'border-gray-600/50'
      }`}>
        <div className="flex items-start gap-3">
          <div className="icon-electric shrink-0">
            <Wallet className={`h-5 w-5 ${
              userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
            }`} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground">Transferring as</p>
            <p className={`text-sm font-medium truncate ${
              userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
            }`}>{userName} (ID: {userId})</p>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              <span className="text-xs text-muted-foreground">
                Reg: {userRegistrationDate}
              </span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                userTransferStatus.internalTransferStatus === 'blocked'
                  ? 'bg-red-900/40 text-red-200 border border-red-700/50'
                  : 'bg-emerald-900/40 text-emerald-200 border border-emerald-700/50'
              }`}>
                Transfer: {userTransferStatus.internalTransferStatus === 'blocked' ? 'Blocked' : 'Allowed'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Balances */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
        {Object.entries(balances).map(([key, val]) => (
          <div
            key={key}
            className={`p-3 rounded-xl bg-gradient-to-br ${getWalletColor(key)} ${
              !userTransferStatus.isTransferAllowed ? 'opacity-70' : ''
            }`}
          >
            <div className="flex items-center justify-between mb-1">
              <p className={`text-xs font-medium ${
                userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
              }`}>{getWalletLabel(key).split(' ')[0]}</p>
              <span className="text-base">{getWalletIcon(key)}</span>
            </div>
            <p className={`text-base sm:text-lg font-bold truncate ${
              userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
            }`}>${val.toFixed(2)}</p>
            {key === 'energy' && (
              <p className={`text-[10px] mt-0.5 ${
                userTransferStatus.isTransferAllowed ? 'text-yellow-400' : 'text-gray-400'
              }`}>Direct referrals</p>
            )}
          </div>
        ))}
      </div>

      {/* Transfer Card */}
      <div className={`rounded-xl p-5 ${
        userTransferStatus.isTransferAllowed 
          ? 'card-glow bg-card' 
          : 'bg-gray-900/50 border border-gray-600/30'
      }`}>
        <div className="flex flex-col md:flex-row md:items-start gap-5">
          {/* From */}
          <div className="flex-1 w-full">
            <label className={`block text-xs font-medium mb-2 ${
              userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
            }`}>From Wallet</label>
            <div className="space-y-2">
              {fromWalletOptions.map((w) => (
                <button
                  key={w}
                  type="button"
                  onClick={() => {
                    if (userTransferStatus.isTransferAllowed) {
                      setFromWallet(w);
                    }
                  }}
                  disabled={!userTransferStatus.isTransferAllowed}
                  className={`w-full p-3 rounded-lg border transition-all text-left ${
                    !userTransferStatus.isTransferAllowed
                      ? 'border-gray-600/30 bg-gray-800/30 cursor-not-allowed'
                      : fromWallet === w
                      ? 'border-primary bg-primary/10'
                      : 'border-border hover:border-primary/60 bg-card'
                  }`}
                >
                  <div className={`text-xs flex items-center justify-between ${
                    userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                  }`}>
                    <span>{getWalletLabel(w)}</span>
                    <span>{getWalletIcon(w)}</span>
                  </div>
                  <div className={`text-xs mt-1 ${
                    userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
                  }`}>${balances[w].toFixed(2)}</div>
                  {w === 'energy' && (
                    <div className={`text-[10px] mt-0.5 ${
                      userTransferStatus.isTransferAllowed ? 'text-yellow-400' : 'text-gray-400'
                    }`}>Direct referral bonus</div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Amount */}
          <div className="flex-1 w-full">
            <label className={`block text-xs font-medium mb-2 ${
              userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
            }`}>
              Amount (Min: ${transferLimits.minTransferAmount})
            </label>
            <div className="relative">
              <input
                type="number"
                step="0.01"
                min={transferLimits.minTransferAmount}
                max={Math.min(balances[fromWallet], transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount)}
                value={amount}
                onChange={(e) => {
                  if (userTransferStatus.isTransferAllowed) {
                    setAmount(e.target.value);
                  }
                }}
                disabled={!userTransferStatus.isTransferAllowed}
                placeholder="0.00"
                className={`w-full border rounded-lg px-4 py-4 text-xl font-bold text-center focus:outline-none focus:ring-1 ${
                  userTransferStatus.isTransferAllowed
                    ? 'bg-background border-border text-foreground focus:border-primary focus:ring-ring'
                    : 'bg-gray-800/30 border-gray-600/30 text-gray-400 cursor-not-allowed'
                }`}
              />
              <div className={`absolute right-3 top-1/2 -translate-y-1/2 text-xs font-medium ${
                userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
              }`}>
                USD
              </div>
            </div>

            {userTransferStatus.isTransferAllowed ? (
              <div className="flex flex-wrap gap-1.5 mt-3">
                {[10, 25, 50, 100].map((v) => (
                  <button
                    key={v}
                    type="button"
                    onClick={() => setAmount(v.toString())}
                    className="px-2.5 py-1 bg-primary/10 hover:bg-primary/20 border border-primary/30 rounded text-xs text-primary transition"
                  >
                    ${v}
                  </button>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const maxAllowed = Math.min(
                      balances[fromWallet],
                      transferLimits.maxDailyAmount - transferLimits.dailyTransferAmount
                    );
                    setAmount(maxAllowed.toFixed(2));
                  }}
                  className="px-2.5 py-1 bg-emerald-900/30 hover:bg-emerald-800/40 border border-emerald-700/40 rounded text-xs text-emerald-300 transition"
                >
                  MAX
                </button>
              </div>
            ) : (
              <div className="mt-3 text-xs text-gray-400">
                Amount selection disabled
              </div>
            )}
            
            {/* Validation messages */}
            {userTransferStatus.isTransferAllowed && amount && Number(amount) < transferLimits.minTransferAmount && (
              <div className="mt-2 text-xs text-red-400 flex items-center gap-1">
                <AlertCircle className="h-3 w-3" />
                Min amount is ${transferLimits.minTransferAmount}
              </div>
            )}
            {userTransferStatus.isTransferAllowed && amount && (Number(amount) + transferLimits.dailyTransferAmount) > transferLimits.maxDailyAmount && (
              <div className="mt-2 text-xs text-red-400 flex items-center gap-1">
                <AlertCircle className="h-3 w-3" />
                Would exceed daily limit of ${transferLimits.maxDailyAmount}
              </div>
            )}
          </div>

          {/* To */}
          <div className="flex-1 w-full">
            <label className={`block text-xs font-medium mb-2 ${
              userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
            }`}>To Wallet</label>
            <div className="space-y-2">
              {toWalletOptions.map((w) => (
                <button
                  key={w}
                  type="button"
                  onClick={() => {
                    if (userTransferStatus.isTransferAllowed) {
                      setToWallet(w);
                    }
                  }}
                  disabled={!userTransferStatus.isTransferAllowed}
                  className={`w-full p-3 rounded-lg border transition-all text-left ${
                    !userTransferStatus.isTransferAllowed
                      ? 'border-gray-600/30 bg-gray-800/30 cursor-not-allowed'
                      : toWallet === w
                      ? 'border-primary bg-primary/10'
                      : 'border-border hover:border-primary/60 bg-card'
                  }`}
                >
                  <div className={`text-xs flex items-center justify-between ${
                    userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                  }`}>
                    <span>{getWalletLabel(w)}</span>
                    <span>{getWalletIcon(w)}</span>
                  </div>
                  <div className={`text-xs mt-1 ${
                    userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
                  }`}>${balances[w].toFixed(2)}</div>
                  <div className={`text-[10px] mt-0.5 ${
                    userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
                  }`}>For package purchases</div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Summary & Button */}
        <div className={`mt-6 pt-5 ${
          userTransferStatus.isTransferAllowed ? 'border-t border-border' : 'border-t border-gray-600/30'
        }`}>
          <div className={`rounded-lg p-4 mb-5 ${
            userTransferStatus.isTransferAllowed ? 'bg-background/60' : 'bg-gray-800/30'
          }`}>
            <div className="grid grid-cols-2 gap-3 text-xs">
              <div>
                <div className={`mb-0.5 ${
                  userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
                }`}>From</div>
                <div className={`font-medium flex items-center gap-1 ${
                  userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                }`}>
                  <span>{getWalletIcon(fromWallet)}</span>
                  <span className="truncate">{getWalletLabel(fromWallet)}</span>
                </div>
              </div>
              <div>
                <div className={`mb-0.5 ${
                  userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
                }`}>To</div>
                <div className={`font-medium flex items-center gap-1 ${
                  userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                }`}>
                  <span>{getWalletIcon(toWallet)}</span>
                  <span className="truncate">{getWalletLabel(toWallet)}</span>
                </div>
              </div>
              <div>
                <div className={`mb-0.5 ${
                  userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
                }`}>Amount</div>
                <div className={`text-base font-bold ${
                  userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                }`}>
                  {amount ? `$${Number(amount).toFixed(2)}` : '—'}
                </div>
              </div>
              <div>
                <div className={`mb-0.5 ${
                  userTransferStatus.isTransferAllowed ? 'text-primary' : 'text-gray-400'
                }`}>New {getWalletLabel(toWallet).split(' ')[0]}</div>
                <div className={`text-base font-bold ${
                  userTransferStatus.isTransferAllowed ? 'text-emerald-400' : 'text-gray-400'
                }`}>
                  ${(balances[toWallet] + Number(amount || 0)).toFixed(2)}
                </div>
              </div>
            </div>
            
            {/* Daily limits summary */}
            {userTransferStatus.isTransferAllowed && amount && Number(amount) >= transferLimits.minTransferAmount && (
              <div className={`mt-4 pt-3 ${
                userTransferStatus.isTransferAllowed ? 'border-t border-border/30' : 'border-t border-gray-600/30'
              }`}>
                <div className={`text-xs mb-1.5 ${
                  userTransferStatus.isTransferAllowed ? 'text-muted-foreground' : 'text-gray-400'
                }`}>Daily Limits Summary</div>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <div className={`text-[10px] ${
                      userTransferStatus.isTransferAllowed ? 'text-blue-300' : 'text-gray-400'
                    }`}>Transfers Today</div>
                    <div className={`font-medium ${
                      userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                    }`}>
                      {transferLimits.dailyTransferCount} → {transferLimits.dailyTransferCount + 1} / {transferLimits.maxDailyTransfers}
                    </div>
                  </div>
                  <div>
                    <div className={`text-[10px] ${
                      userTransferStatus.isTransferAllowed ? 'text-emerald-300' : 'text-gray-400'
                    }`}>Amount Today</div>
                    <div className={`font-medium ${
                      userTransferStatus.isTransferAllowed ? 'text-foreground' : 'text-gray-400'
                    }`}>
                      ${transferLimits.dailyTransferAmount.toFixed(2)} → ${(transferLimits.dailyTransferAmount + Number(amount)).toFixed(2)} / ${transferLimits.maxDailyAmount}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {userTransferStatus.isTransferAllowed ? (
              <>
                <button
                  onClick={handleTransfer}
                  disabled={isSubmitDisabled}
                  className="btn-electric disabled:opacity-50 disabled:cursor-not-allowed py-3 px-8 rounded-lg text-sm transition shadow-lg flex items-center justify-center gap-2 min-w-[200px]"
                >
                  {saving ? (
                    <>
                      <Loader2 className="h-4 w-4 animate-spin" />
                      Processing...
                    </>
                  ) : (
                    <>
                      <ArrowRightLeft className="h-4 w-4" />
                      Confirm Transfer
                    </>
                  )}
                </button>

                <button
                  onClick={() => {
                    setAmount('');
                    setFromWallet('working');
                    setToWallet('aurum');
                  }}
                  className="border border-border hover:bg-primary/5 text-foreground px-8 py-3 rounded-lg text-sm transition"
                >
                  Cancel
                </button>
              </>
            ) : (
              <div className="w-full text-center py-4">
                <Ban className="h-8 w-8 text-red-400 mx-auto mb-2" />
                <p className="text-red-300 font-medium text-sm mb-1">Transfer Functionality Disabled</p>
                <p className="text-gray-400 text-xs">Your account's transfer feature is currently blocked. Please contact support.</p>
              </div>
            )}
          </div>
        </div>

        {error && (
          <div className="mt-4 p-3 bg-destructive/10 border border-destructive/30 rounded-lg text-destructive-foreground text-xs text-center">
            {error}
          </div>
        )}
      </div>

    
    </div>
  );
};

export default Transfer;